import { jsxs as Tt, jsx as Pe, Fragment as xr } from "react/jsx-runtime";
import { Typography as kr, Button as br } from "@mui/material";
import { B as wr } from "./index-BcZ70a8s.js";
import { C as Sr } from "./index-D8rQzb7O.js";
import { FormFieldFlags as Cr } from "./helpers/daymaptypes.js";
import "react";
import { a as Pt } from "./_commonjsHelpers-BItOPCY9.js";
function Er(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Ir = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Tr = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Pr = {};
function Un(e, n) {
  return (Pr.jsx ? Tr : Ir).test(e);
}
const Ar = /[ \t\n\f\r]/g;
function zr(e) {
  return typeof e == "object" ? e.type === "text" ? Vn(e.value) : !1 : Vn(e);
}
function Vn(e) {
  return e.replace(Ar, "") === "";
}
class He {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(n, t, r) {
    this.normal = t, this.property = n, r && (this.space = r);
  }
}
He.prototype.normal = {};
He.prototype.property = {};
He.prototype.space = void 0;
function At(e, n) {
  const t = {}, r = {};
  for (const i of e)
    Object.assign(t, i.property), Object.assign(r, i.normal);
  return new He(t, r, n);
}
function hn(e) {
  return e.toLowerCase();
}
class J {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(n, t) {
    this.attribute = t, this.property = n;
  }
}
J.prototype.attribute = "";
J.prototype.booleanish = !1;
J.prototype.boolean = !1;
J.prototype.commaOrSpaceSeparated = !1;
J.prototype.commaSeparated = !1;
J.prototype.defined = !1;
J.prototype.mustUseProperty = !1;
J.prototype.number = !1;
J.prototype.overloadedBoolean = !1;
J.prototype.property = "";
J.prototype.spaceSeparated = !1;
J.prototype.space = void 0;
let Lr = 0;
const v = be(), W = be(), mn = be(), x = be(), H = be(), ke = be(), ee = be();
function be() {
  return 2 ** ++Lr;
}
const dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: v,
  booleanish: W,
  commaOrSpaceSeparated: ee,
  commaSeparated: ke,
  number: x,
  overloadedBoolean: mn,
  spaceSeparated: H
}, Symbol.toStringTag, { value: "Module" })), Ze = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(dn)
);
class Cn extends J {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(n, t, r, i) {
    let l = -1;
    if (super(n, t), qn(this, "space", i), typeof r == "number")
      for (; ++l < Ze.length; ) {
        const o = Ze[l];
        qn(this, Ze[l], (r & dn[o]) === dn[o]);
      }
  }
}
Cn.prototype.defined = !0;
function qn(e, n, t) {
  t && (e[n] = t);
}
function Ae(e) {
  const n = {}, t = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const l = new Cn(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (l.mustUseProperty = !0), n[r] = l, t[hn(r)] = r, t[hn(l.attribute)] = r;
  }
  return new He(n, t, e.space);
}
const zt = Ae({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: W,
    ariaAutoComplete: null,
    ariaBusy: W,
    ariaChecked: W,
    ariaColCount: x,
    ariaColIndex: x,
    ariaColSpan: x,
    ariaControls: H,
    ariaCurrent: null,
    ariaDescribedBy: H,
    ariaDetails: null,
    ariaDisabled: W,
    ariaDropEffect: H,
    ariaErrorMessage: null,
    ariaExpanded: W,
    ariaFlowTo: H,
    ariaGrabbed: W,
    ariaHasPopup: null,
    ariaHidden: W,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: H,
    ariaLevel: x,
    ariaLive: null,
    ariaModal: W,
    ariaMultiLine: W,
    ariaMultiSelectable: W,
    ariaOrientation: null,
    ariaOwns: H,
    ariaPlaceholder: null,
    ariaPosInSet: x,
    ariaPressed: W,
    ariaReadOnly: W,
    ariaRelevant: null,
    ariaRequired: W,
    ariaRoleDescription: H,
    ariaRowCount: x,
    ariaRowIndex: x,
    ariaRowSpan: x,
    ariaSelected: W,
    ariaSetSize: x,
    ariaSort: null,
    ariaValueMax: x,
    ariaValueMin: x,
    ariaValueNow: x,
    ariaValueText: null,
    role: null
  },
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  }
});
function Lt(e, n) {
  return n in e ? e[n] : n;
}
function vt(e, n) {
  return Lt(e, n.toLowerCase());
}
const vr = Ae({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ke,
    acceptCharset: H,
    accessKey: H,
    action: null,
    allow: null,
    allowFullScreen: v,
    allowPaymentRequest: v,
    allowUserMedia: v,
    alpha: v,
    alt: null,
    as: null,
    async: v,
    autoCapitalize: null,
    autoComplete: H,
    autoFocus: v,
    autoPlay: v,
    blocking: H,
    capture: null,
    charSet: null,
    checked: v,
    cite: null,
    className: H,
    closedBy: null,
    colorSpace: null,
    cols: x,
    colSpan: x,
    command: null,
    commandFor: null,
    content: null,
    contentEditable: W,
    controls: v,
    controlsList: H,
    coords: x | ke,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: v,
    defer: v,
    dir: null,
    dirName: null,
    disabled: v,
    download: mn,
    draggable: W,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: v,
    formTarget: null,
    headers: H,
    height: x,
    hidden: mn,
    high: x,
    href: null,
    hrefLang: null,
    htmlFor: H,
    httpEquiv: H,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: v,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: v,
    itemId: null,
    itemProp: H,
    itemRef: H,
    itemScope: v,
    itemType: H,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: v,
    low: x,
    manifest: null,
    max: null,
    maxLength: x,
    media: null,
    method: null,
    min: null,
    minLength: x,
    multiple: v,
    muted: v,
    name: null,
    nonce: null,
    noModule: v,
    noValidate: v,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: v,
    optimum: x,
    pattern: null,
    ping: H,
    placeholder: null,
    playsInline: v,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: v,
    referrerPolicy: null,
    rel: H,
    required: v,
    reversed: v,
    rows: x,
    rowSpan: x,
    sandbox: H,
    scope: null,
    scoped: v,
    seamless: v,
    selected: v,
    shadowRootClonable: v,
    shadowRootCustomElementRegistry: v,
    shadowRootDelegatesFocus: v,
    shadowRootMode: null,
    shadowRootSerializable: v,
    shape: null,
    size: x,
    sizes: null,
    slot: null,
    span: x,
    spellCheck: W,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: x,
    step: null,
    style: null,
    tabIndex: x,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: v,
    useMap: null,
    value: W,
    width: x,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: H,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: x,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: x,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: v,
    // Lists. Use CSS to reduce space between items instead
    declare: v,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: x,
    // `<img>` and `<object>`
    leftMargin: x,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: x,
    // `<body>`
    marginWidth: x,
    // `<body>`
    noResize: v,
    // `<frame>`
    noHref: v,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: v,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: v,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: x,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: W,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: x,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: x,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    credentialless: v,
    disablePictureInPicture: v,
    disableRemotePlayback: v,
    exportParts: ke,
    part: H,
    prefix: null,
    property: null,
    results: x,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: vt
}), Dr = Ae({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    maskType: "mask-type",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: ee,
    accentHeight: x,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: x,
    amplitude: x,
    arabicForm: null,
    ascent: x,
    attributeName: null,
    attributeType: null,
    azimuth: x,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: x,
    by: null,
    calcMode: null,
    capHeight: x,
    className: H,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: x,
    diffuseConstant: x,
    direction: null,
    display: null,
    dur: null,
    divisor: x,
    dominantBaseline: null,
    download: v,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: x,
    enableBackground: null,
    end: null,
    event: null,
    exponent: x,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: x,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ke,
    g2: ke,
    glyphName: ke,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: x,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: x,
    horizOriginX: x,
    horizOriginY: x,
    id: null,
    ideographic: x,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: x,
    k: x,
    k1: x,
    k2: x,
    k3: x,
    k4: x,
    kernelMatrix: ee,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: x,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskType: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: x,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: x,
    overlineThickness: x,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: x,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: H,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: x,
    pointsAtY: x,
    pointsAtZ: x,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ee,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ee,
    rev: ee,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ee,
    requiredFeatures: ee,
    requiredFonts: ee,
    requiredFormats: ee,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: x,
    specularExponent: x,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: x,
    strikethroughThickness: x,
    string: null,
    stroke: null,
    strokeDashArray: ee,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: x,
    strokeOpacity: x,
    strokeWidth: null,
    style: null,
    surfaceScale: x,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ee,
    tabIndex: x,
    tableValues: null,
    target: null,
    targetX: x,
    targetY: x,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ee,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: x,
    underlineThickness: x,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: x,
    values: null,
    vAlphabetic: x,
    vMathematical: x,
    vectorEffect: null,
    vHanging: x,
    vIdeographic: x,
    version: null,
    vertAdvY: x,
    vertOriginX: x,
    vertOriginY: x,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: x,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Lt
}), Dt = Ae({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  }
}), Ot = Ae({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: vt
}), Ft = Ae({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  }
}), Or = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Fr = /[A-Z]/g, $n = /-[a-z]/g, _r = /^data[-\w.:]+$/i;
function Rr(e, n) {
  const t = hn(n);
  let r = n, i = J;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && _r.test(n)) {
    if (n.charAt(4) === "-") {
      const l = n.slice(5).replace($n, Mr);
      r = "data" + l.charAt(0).toUpperCase() + l.slice(1);
    } else {
      const l = n.slice(4);
      if (!$n.test(l)) {
        let o = l.replace(Fr, Nr);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    i = Cn;
  }
  return new i(r, n);
}
function Nr(e) {
  return "-" + e.toLowerCase();
}
function Mr(e) {
  return e.charAt(1).toUpperCase();
}
const Br = At([zt, vr, Dt, Ot, Ft], "html"), En = At([zt, Dr, Dt, Ot, Ft], "svg");
function jr(e) {
  return e.join(" ").trim();
}
var Ee = {}, en, Wn;
function Hr() {
  if (Wn) return en;
  Wn = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, t = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, l = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, a = /^\s+|\s+$/g, c = `
`, u = "/", s = "*", f = "", d = "comment", p = "declaration";
  function w(I, k) {
    if (typeof I != "string")
      throw new TypeError("First argument must be a string");
    if (!I) return [];
    k = k || {};
    var L = 1, E = 1;
    function B(A) {
      var S = A.match(n);
      S && (L += S.length);
      var M = A.lastIndexOf(c);
      E = ~M ? A.length - M : E + A.length;
    }
    function U() {
      var A = { line: L, column: E };
      return function(S) {
        return S.position = new y(A), R(), S;
      };
    }
    function y(A) {
      this.start = A, this.end = { line: L, column: E }, this.source = k.source;
    }
    y.prototype.content = I;
    function F(A) {
      var S = new Error(
        k.source + ":" + L + ":" + E + ": " + A
      );
      if (S.reason = A, S.filename = k.source, S.line = L, S.column = E, S.source = I, !k.silent) throw S;
    }
    function V(A) {
      var S = A.exec(I);
      if (S) {
        var M = S[0];
        return B(M), I = I.slice(M.length), S;
      }
    }
    function R() {
      V(t);
    }
    function N(A) {
      var S;
      for (A = A || []; S = P(); )
        S !== !1 && A.push(S);
      return A;
    }
    function P() {
      var A = U();
      if (!(u != I.charAt(0) || s != I.charAt(1))) {
        for (var S = 2; f != I.charAt(S) && (s != I.charAt(S) || u != I.charAt(S + 1)); )
          ++S;
        if (S += 2, f === I.charAt(S - 1))
          return F("End of comment missing");
        var M = I.slice(2, S - 2);
        return E += 2, B(M), I = I.slice(S), E += 2, A({
          type: d,
          comment: M
        });
      }
    }
    function T() {
      var A = U(), S = V(r);
      if (S) {
        if (P(), !V(i)) return F("property missing ':'");
        var M = V(l), Y = A({
          type: p,
          property: C(S[0].replace(e, f)),
          value: M ? C(M[0].replace(e, f)) : f
        });
        return V(o), Y;
      }
    }
    function q() {
      var A = [];
      N(A);
      for (var S; S = T(); )
        S !== !1 && (A.push(S), N(A));
      return A;
    }
    return R(), q();
  }
  function C(I) {
    return I ? I.replace(a, f) : f;
  }
  return en = w, en;
}
var Yn;
function Ur() {
  if (Yn) return Ee;
  Yn = 1;
  var e = Ee && Ee.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Ee, "__esModule", { value: !0 }), Ee.default = t;
  const n = e(Hr());
  function t(r, i) {
    let l = null;
    if (!r || typeof r != "string")
      return l;
    const o = (0, n.default)(r), a = typeof i == "function";
    return o.forEach((c) => {
      if (c.type !== "declaration")
        return;
      const { property: u, value: s } = c;
      a ? i(u, s, c) : s && (l = l || {}, l[u] = s);
    }), l;
  }
  return Ee;
}
var Oe = {}, Xn;
function Vr() {
  if (Xn) return Oe;
  Xn = 1, Object.defineProperty(Oe, "__esModule", { value: !0 }), Oe.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, n = /-([a-z])/g, t = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, l = function(u) {
    return !u || t.test(u) || e.test(u);
  }, o = function(u, s) {
    return s.toUpperCase();
  }, a = function(u, s) {
    return "".concat(s, "-");
  }, c = function(u, s) {
    return s === void 0 && (s = {}), l(u) ? u : (u = u.toLowerCase(), s.reactCompat ? u = u.replace(i, a) : u = u.replace(r, a), u.replace(n, o));
  };
  return Oe.camelCase = c, Oe;
}
var Fe, Qn;
function qr() {
  if (Qn) return Fe;
  Qn = 1;
  var e = Fe && Fe.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, n = e(Ur()), t = Vr();
  function r(i, l) {
    var o = {};
    return !i || typeof i != "string" || (0, n.default)(i, function(a, c) {
      a && c && (o[(0, t.camelCase)(a, l)] = c);
    }), o;
  }
  return r.default = r, Fe = r, Fe;
}
var $r = qr();
const Wr = /* @__PURE__ */ Pt($r), _t = Rt("end"), In = Rt("start");
function Rt(e) {
  return n;
  function n(t) {
    const r = t && t.position && t.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function Yr(e) {
  const n = In(e), t = _t(e);
  if (n && t)
    return { start: n, end: t };
}
function Ne(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Kn(e.position) : "start" in e || "end" in e ? Kn(e) : "line" in e || "column" in e ? gn(e) : "";
}
function gn(e) {
  return Gn(e && e.line) + ":" + Gn(e && e.column);
}
function Kn(e) {
  return gn(e && e.start) + "-" + gn(e && e.end);
}
function Gn(e) {
  return e && typeof e == "number" ? e : 1;
}
class Q extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, r) {
    super(), typeof t == "string" && (r = t, t = void 0);
    let i = "", l = {}, o = !1;
    if (t && ("line" in t && "column" in t ? l = { place: t } : "start" in t && "end" in t ? l = { place: t } : "type" in t ? l = {
      ancestors: [t],
      place: t.position
    } : l = { ...t }), typeof n == "string" ? i = n : !l.cause && n && (o = !0, i = n.message, l.cause = n), !l.ruleId && !l.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? l.ruleId = r : (l.source = r.slice(0, c), l.ruleId = r.slice(c + 1));
    }
    if (!l.place && l.ancestors && l.ancestors) {
      const c = l.ancestors[l.ancestors.length - 1];
      c && (l.place = c.position);
    }
    const a = l.place && "start" in l.place ? l.place.start : l.place;
    this.ancestors = l.ancestors || void 0, this.cause = l.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file = "", this.message = i, this.line = a ? a.line : void 0, this.name = Ne(l.place) || "1:1", this.place = l.place || void 0, this.reason = this.message, this.ruleId = l.ruleId || void 0, this.source = l.source || void 0, this.stack = o && l.cause && typeof l.cause.stack == "string" ? l.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Q.prototype.file = "";
Q.prototype.name = "";
Q.prototype.reason = "";
Q.prototype.message = "";
Q.prototype.stack = "";
Q.prototype.column = void 0;
Q.prototype.line = void 0;
Q.prototype.ancestors = void 0;
Q.prototype.cause = void 0;
Q.prototype.fatal = void 0;
Q.prototype.place = void 0;
Q.prototype.ruleId = void 0;
Q.prototype.source = void 0;
const Tn = {}.hasOwnProperty, Xr = /* @__PURE__ */ new Map(), Qr = /[A-Z]/g, Kr = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Gr = /* @__PURE__ */ new Set(["td", "th"]), Nt = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Jr(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let r;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = oi(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = li(t, n.jsx, n.jsxs);
  }
  const i = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: r,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? En : Br,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, l = Mt(i, e, void 0);
  return l && typeof l != "string" ? l : i.create(
    e,
    i.Fragment,
    { children: l || void 0 },
    void 0
  );
}
function Mt(e, n, t) {
  if (n.type === "element")
    return Zr(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return ei(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return ti(e, n, t);
  if (n.type === "mdxjsEsm")
    return ni(e, n);
  if (n.type === "root")
    return ri(e, n, t);
  if (n.type === "text")
    return ii(e, n);
}
function Zr(e, n, t) {
  const r = e.schema;
  let i = r;
  n.tagName.toLowerCase() === "svg" && r.space === "html" && (i = En, e.schema = i), e.ancestors.push(n);
  const l = jt(e, n.tagName, !1), o = ai(e, n);
  let a = An(e, n);
  return Kr.has(n.tagName) && (a = a.filter(function(c) {
    return typeof c == "string" ? !zr(c) : !0;
  })), Bt(e, o, l, n), Pn(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function ei(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const r = n.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  je(e, n.position);
}
function ni(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  je(e, n.position);
}
function ti(e, n, t) {
  const r = e.schema;
  let i = r;
  n.name === "svg" && r.space === "html" && (i = En, e.schema = i), e.ancestors.push(n);
  const l = n.name === null ? e.Fragment : jt(e, n.name, !0), o = ui(e, n), a = An(e, n);
  return Bt(e, o, l, n), Pn(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function ri(e, n, t) {
  const r = {};
  return Pn(r, An(e, n)), e.create(n, e.Fragment, r, t);
}
function ii(e, n) {
  return n.value;
}
function Bt(e, n, t, r) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = r);
}
function Pn(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function li(e, n, t) {
  return r;
  function r(i, l, o, a) {
    const u = Array.isArray(o.children) ? t : n;
    return a ? u(l, o, a) : u(l, o);
  }
}
function oi(e, n) {
  return t;
  function t(r, i, l, o) {
    const a = Array.isArray(l.children), c = In(r);
    return n(
      i,
      l,
      o,
      a,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function ai(e, n) {
  const t = {};
  let r, i;
  for (i in n.properties)
    if (i !== "children" && Tn.call(n.properties, i)) {
      const l = si(e, i, n.properties[i]);
      if (l) {
        const [o, a] = l;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && Gr.has(n.tagName) ? r = a : t[o] = a;
      }
    }
  if (r) {
    const l = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    l[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return t;
}
function ui(e, n) {
  const t = {};
  for (const r of n.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const l = r.data.estree.body[0];
        l.type;
        const o = l.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        je(e, n.position);
    else {
      const i = r.name;
      let l;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, l = e.evaluater.evaluateExpression(a.expression);
        } else
          je(e, n.position);
      else
        l = r.value === null ? !0 : r.value;
      t[i] = /** @type {Props[keyof Props]} */
      l;
    }
  return t;
}
function An(e, n) {
  const t = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : Xr;
  for (; ++r < n.children.length; ) {
    const l = n.children[r];
    let o;
    if (e.passKeys) {
      const c = l.type === "element" ? l.tagName : l.type === "mdxJsxFlowElement" || l.type === "mdxJsxTextElement" ? l.name : void 0;
      if (c) {
        const u = i.get(c) || 0;
        o = c + "-" + u, i.set(c, u + 1);
      }
    }
    const a = Mt(e, l, o);
    a !== void 0 && t.push(a);
  }
  return t;
}
function si(e, n, t) {
  const r = Rr(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = r.commaSeparated ? Er(t) : jr(t)), r.property === "style") {
      let i = typeof t == "object" ? t : ci(e, String(t));
      return e.stylePropertyNameCase === "css" && (i = pi(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Or[r.property] || r.property : r.attribute,
      t
    ];
  }
}
function ci(e, n) {
  try {
    return Wr(n, { reactCompat: !0 });
  } catch (t) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      t
    ), i = new Q("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Nt + "#cannot-parse-style-attribute", i;
  }
}
function jt(e, n, t) {
  let r;
  if (!t)
    r = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const i = n.split(".");
    let l = -1, o;
    for (; ++l < i.length; ) {
      const a = Un(i[l]) ? { type: "Identifier", name: i[l] } : { type: "Literal", value: i[l] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(l && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = o;
  } else
    r = Un(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return Tn.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  je(e);
}
function je(e, n) {
  const t = new Q(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = Nt + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function pi(e) {
  const n = {};
  let t;
  for (t in e)
    Tn.call(e, t) && (n[fi(t)] = e[t]);
  return n;
}
function fi(e) {
  let n = e.replace(Qr, hi);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function hi(e) {
  return "-" + e.toLowerCase();
}
const nn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, mi = {};
function di(e, n) {
  const t = mi, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Ht(e, r, i);
}
function Ht(e, n, t) {
  if (gi(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Jn(e.children, n, t);
  }
  return Array.isArray(e) ? Jn(e, n, t) : "";
}
function Jn(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Ht(e[i], n, t);
  return r.join("");
}
function gi(e) {
  return !!(e && typeof e == "object");
}
const Zn = document.createElement("i");
function zn(e) {
  const n = "&" + e + ";";
  Zn.innerHTML = n;
  const t = Zn.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function se(e, n, t, r) {
  const i = e.length;
  let l = 0, o;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); l < r.length; )
      o = r.slice(l, l + 1e4), o.unshift(n, 0), e.splice(...o), l += 1e4, n += 1e4;
}
function te(e, n) {
  return e.length > 0 ? (se(e, e.length, 0, n), e) : n;
}
const et = {}.hasOwnProperty;
function yi(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    xi(n, e[t]);
  return n;
}
function xi(e, n) {
  let t;
  for (t in n) {
    const i = (et.call(e, t) ? e[t] : void 0) || (e[t] = {}), l = n[t];
    let o;
    if (l)
      for (o in l) {
        et.call(i, o) || (i[o] = []);
        const a = l[o];
        ki(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function ki(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  se(e, 0, 0, r);
}
function Ut(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function Te(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const ue = ge(/[A-Za-z]/), ne = ge(/[\dA-Za-z]/), bi = ge(/[#-'*+\--9=?A-Z^-~]/);
function yn(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const xn = ge(/\d/), wi = ge(/[\dA-Fa-f]/), Si = ge(/[!-/:-@[-`{-~]/);
function z(e) {
  return e !== null && e < -2;
}
function G(e) {
  return e !== null && (e < 0 || e === 32);
}
function _(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ci = ge(new RegExp("\\p{P}|\\p{S}", "u")), Ei = ge(/\s/);
function ge(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function ze(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const l = e.charCodeAt(t);
    let o = "";
    if (l === 37 && ne(e.charCodeAt(t + 1)) && ne(e.charCodeAt(t + 2)))
      i = 2;
    else if (l < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(l)) || (o = String.fromCharCode(l));
    else if (l > 55295 && l < 57344) {
      const a = e.charCodeAt(t + 1);
      l < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(l, a), i = 1) : o = "�";
    } else
      o = String.fromCharCode(l);
    o && (n.push(e.slice(r, t), encodeURIComponent(o)), r = t + i + 1, o = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function $(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return o;
  function o(c) {
    return _(c) ? (e.enter(t), a(c)) : n(c);
  }
  function a(c) {
    return _(c) && l++ < i ? (e.consume(c), a) : (e.exit(t), n(c));
  }
}
const Ii = {
  tokenize: Ti
};
function Ti(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, r, i);
  let t;
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), $(e, n, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), l(a);
  }
  function l(a) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = c), t = c, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return z(a) ? (e.consume(a), e.exit("chunkText"), l) : (e.consume(a), o);
  }
}
const Pi = {
  tokenize: Ai
}, nt = {
  tokenize: zi
};
function Ai(e) {
  const n = this, t = [];
  let r = 0, i, l, o;
  return a;
  function a(E) {
    if (r < t.length) {
      const B = t[r];
      return n.containerState = B[1], e.attempt(B[0].continuation, c, u)(E);
    }
    return u(E);
  }
  function c(E) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && L();
      const B = n.events.length;
      let U = B, y;
      for (; U--; )
        if (n.events[U][0] === "exit" && n.events[U][1].type === "chunkFlow") {
          y = n.events[U][1].end;
          break;
        }
      k(r);
      let F = B;
      for (; F < n.events.length; )
        n.events[F][1].end = {
          ...y
        }, F++;
      return se(n.events, U + 1, 0, n.events.slice(B)), n.events.length = F, u(E);
    }
    return a(E);
  }
  function u(E) {
    if (r === t.length) {
      if (!i)
        return d(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return w(E);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(nt, s, f)(E);
  }
  function s(E) {
    return i && L(), k(r), d(E);
  }
  function f(E) {
    return n.parser.lazy[n.now().line] = r !== t.length, o = n.now().offset, w(E);
  }
  function d(E) {
    return n.containerState = {}, e.attempt(nt, p, w)(E);
  }
  function p(E) {
    return r++, t.push([n.currentConstruct, n.containerState]), d(E);
  }
  function w(E) {
    if (E === null) {
      i && L(), k(0), e.consume(E);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: l
    }), C(E);
  }
  function C(E) {
    if (E === null) {
      I(e.exit("chunkFlow"), !0), k(0), e.consume(E);
      return;
    }
    return z(E) ? (e.consume(E), I(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, a) : (e.consume(E), C);
  }
  function I(E, B) {
    const U = n.sliceStream(E);
    if (B && U.push(null), E.previous = l, l && (l.next = E), l = E, i.defineSkip(E.start), i.write(U), n.parser.lazy[E.start.line]) {
      let y = i.events.length;
      for (; y--; )
        if (
          // The token starts before the line ending…
          i.events[y][1].start.offset < o && // …and either is not ended yet…
          (!i.events[y][1].end || // …or ends after it.
          i.events[y][1].end.offset > o)
        )
          return;
      const F = n.events.length;
      let V = F, R, N;
      for (; V--; )
        if (n.events[V][0] === "exit" && n.events[V][1].type === "chunkFlow") {
          if (R) {
            N = n.events[V][1].end;
            break;
          }
          R = !0;
        }
      for (k(r), y = F; y < n.events.length; )
        n.events[y][1].end = {
          ...N
        }, y++;
      se(n.events, V + 1, 0, n.events.slice(F)), n.events.length = y;
    }
  }
  function k(E) {
    let B = t.length;
    for (; B-- > E; ) {
      const U = t[B];
      n.containerState = U[1], U[0].exit.call(n, e);
    }
    t.length = E;
  }
  function L() {
    i.write([null]), l = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function zi(e, n, t) {
  return $(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function tt(e) {
  if (e === null || G(e) || Ei(e))
    return 1;
  if (Ci(e))
    return 2;
}
function Ln(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const l = e[i].resolveAll;
    l && !r.includes(l) && (n = l(n, t), r.push(l));
  }
  return n;
}
const kn = {
  name: "attention",
  resolveAll: Li,
  tokenize: vi
};
function Li(e, n) {
  let t = -1, r, i, l, o, a, c, u, s;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, d = {
            ...e[t][1].start
          };
          rt(f, -c), rt(d, c), o = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, a = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: d
          }, l = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...a.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[t][1].start = {
            ...a.end
          }, u = [], e[r][1].end.offset - e[r][1].start.offset && (u = te(u, [["enter", e[r][1], n], ["exit", e[r][1], n]])), u = te(u, [["enter", i, n], ["enter", o, n], ["exit", o, n], ["enter", l, n]]), u = te(u, Ln(n.parser.constructs.insideSpan.null, e.slice(r + 1, t), n)), u = te(u, [["exit", l, n], ["enter", a, n], ["exit", a, n], ["exit", i, n]]), e[t][1].end.offset - e[t][1].start.offset ? (s = 2, u = te(u, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : s = 0, se(e, r - 1, t - r + 3, u), t = r + u.length - s - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function vi(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = tt(r);
  let l;
  return o;
  function o(c) {
    return l = c, e.enter("attentionSequence"), a(c);
  }
  function a(c) {
    if (c === l)
      return e.consume(c), a;
    const u = e.exit("attentionSequence"), s = tt(c), f = !s || s === 2 && i || t.includes(c), d = !i || i === 2 && s || t.includes(r);
    return u._open = !!(l === 42 ? f : f && (i || !d)), u._close = !!(l === 42 ? d : d && (s || !f)), n(c);
  }
}
function rt(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const Di = {
  name: "autolink",
  tokenize: Oi
};
function Oi(e, n, t) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), l;
  }
  function l(p) {
    return ue(p) ? (e.consume(p), o) : p === 64 ? t(p) : u(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || ne(p) ? (r = 1, a(p)) : u(p);
  }
  function a(p) {
    return p === 58 ? (e.consume(p), r = 0, c) : (p === 43 || p === 45 || p === 46 || ne(p)) && r++ < 32 ? (e.consume(p), a) : (r = 0, u(p));
  }
  function c(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : p === null || p === 32 || p === 60 || yn(p) ? t(p) : (e.consume(p), c);
  }
  function u(p) {
    return p === 64 ? (e.consume(p), s) : bi(p) ? (e.consume(p), u) : t(p);
  }
  function s(p) {
    return ne(p) ? f(p) : t(p);
  }
  function f(p) {
    return p === 46 ? (e.consume(p), r = 0, s) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : d(p);
  }
  function d(p) {
    if ((p === 45 || ne(p)) && r++ < 63) {
      const w = p === 45 ? d : f;
      return e.consume(p), w;
    }
    return t(p);
  }
}
const Ke = {
  partial: !0,
  tokenize: Fi
};
function Fi(e, n, t) {
  return r;
  function r(l) {
    return _(l) ? $(e, i, "linePrefix")(l) : i(l);
  }
  function i(l) {
    return l === null || z(l) ? n(l) : t(l);
  }
}
const Vt = {
  continuation: {
    tokenize: Ri
  },
  exit: Ni,
  name: "blockQuote",
  tokenize: _i
};
function _i(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), l;
    }
    return t(o);
  }
  function l(o) {
    return _(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function Ri(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return _(o) ? $(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : l(o);
  }
  function l(o) {
    return e.attempt(Vt, n, t)(o);
  }
}
function Ni(e) {
  e.exit("blockQuote");
}
const qt = {
  name: "characterEscape",
  tokenize: Mi
};
function Mi(e, n, t) {
  return r;
  function r(l) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(l), e.exit("escapeMarker"), i;
  }
  function i(l) {
    return Si(l) ? (e.enter("characterEscapeValue"), e.consume(l), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(l);
  }
}
const $t = {
  name: "characterReference",
  tokenize: Bi
};
function Bi(e, n, t) {
  const r = this;
  let i = 0, l, o;
  return a;
  function a(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), l = 31, o = ne, s(f));
  }
  function u(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), l = 6, o = wi, s) : (e.enter("characterReferenceValue"), l = 7, o = xn, s(f));
  }
  function s(f) {
    if (f === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return o === ne && !zn(r.sliceSerialize(d)) ? t(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(f) && i++ < l ? (e.consume(f), s) : t(f);
  }
}
const it = {
  partial: !0,
  tokenize: Hi
}, lt = {
  concrete: !0,
  name: "codeFenced",
  tokenize: ji
};
function ji(e, n, t) {
  const r = this, i = {
    partial: !0,
    tokenize: U
  };
  let l = 0, o = 0, a;
  return c;
  function c(y) {
    return u(y);
  }
  function u(y) {
    const F = r.events[r.events.length - 1];
    return l = F && F[1].type === "linePrefix" ? F[2].sliceSerialize(F[1], !0).length : 0, a = y, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), s(y);
  }
  function s(y) {
    return y === a ? (o++, e.consume(y), s) : o < 3 ? t(y) : (e.exit("codeFencedFenceSequence"), _(y) ? $(e, f, "whitespace")(y) : f(y));
  }
  function f(y) {
    return y === null || z(y) ? (e.exit("codeFencedFence"), r.interrupt ? n(y) : e.check(it, C, B)(y)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(y));
  }
  function d(y) {
    return y === null || z(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(y)) : _(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), $(e, p, "whitespace")(y)) : y === 96 && y === a ? t(y) : (e.consume(y), d);
  }
  function p(y) {
    return y === null || z(y) ? f(y) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), w(y));
  }
  function w(y) {
    return y === null || z(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(y)) : y === 96 && y === a ? t(y) : (e.consume(y), w);
  }
  function C(y) {
    return e.attempt(i, B, I)(y);
  }
  function I(y) {
    return e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), k;
  }
  function k(y) {
    return l > 0 && _(y) ? $(e, L, "linePrefix", l + 1)(y) : L(y);
  }
  function L(y) {
    return y === null || z(y) ? e.check(it, C, B)(y) : (e.enter("codeFlowValue"), E(y));
  }
  function E(y) {
    return y === null || z(y) ? (e.exit("codeFlowValue"), L(y)) : (e.consume(y), E);
  }
  function B(y) {
    return e.exit("codeFenced"), n(y);
  }
  function U(y, F, V) {
    let R = 0;
    return N;
    function N(S) {
      return y.enter("lineEnding"), y.consume(S), y.exit("lineEnding"), P;
    }
    function P(S) {
      return y.enter("codeFencedFence"), _(S) ? $(y, T, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(S) : T(S);
    }
    function T(S) {
      return S === a ? (y.enter("codeFencedFenceSequence"), q(S)) : V(S);
    }
    function q(S) {
      return S === a ? (R++, y.consume(S), q) : R >= o ? (y.exit("codeFencedFenceSequence"), _(S) ? $(y, A, "whitespace")(S) : A(S)) : V(S);
    }
    function A(S) {
      return S === null || z(S) ? (y.exit("codeFencedFence"), F(S)) : V(S);
    }
  }
}
function Hi(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
const tn = {
  name: "codeIndented",
  tokenize: Vi
}, Ui = {
  partial: !0,
  tokenize: qi
};
function Vi(e, n, t) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), $(e, l, "linePrefix", 5)(u);
  }
  function l(u) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? o(u) : t(u);
  }
  function o(u) {
    return u === null ? c(u) : z(u) ? e.attempt(Ui, o, c)(u) : (e.enter("codeFlowValue"), a(u));
  }
  function a(u) {
    return u === null || z(u) ? (e.exit("codeFlowValue"), o(u)) : (e.consume(u), a);
  }
  function c(u) {
    return e.exit("codeIndented"), n(u);
  }
}
function qi(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? t(o) : z(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : $(e, l, "linePrefix", 5)(o);
  }
  function l(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : z(o) ? i(o) : t(o);
  }
}
const $i = {
  name: "codeText",
  previous: Yi,
  resolve: Wi,
  tokenize: Xi
};
function Wi(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Yi(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Xi(e, n, t) {
  let r = 0, i, l;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(f);
  }
  function a(f) {
    return f === 96 ? (e.consume(f), r++, a) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? t(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (l = e.enter("codeTextSequence"), i = 0, s(f)) : z(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), u(f));
  }
  function u(f) {
    return f === null || f === 32 || f === 96 || z(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), u);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), i++, s) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (l.type = "codeTextData", u(f));
  }
}
class Qi {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const r = t ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(n, r) : n > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, r) {
    const i = t || 0;
    this.setCursor(Math.trunc(n));
    const l = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && _e(this.left, r), l.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), _e(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), _e(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        _e(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        _e(this.left, t.reverse());
      }
  }
}
function _e(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function Wt(e) {
  const n = {};
  let t = -1, r, i, l, o, a, c, u;
  const s = new Qi(e);
  for (; ++t < s.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = s.get(t), t && r[1].type === "chunkFlow" && s.get(t - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, l = 0, l < c.length && c[l][1].type === "lineEndingBlank" && (l += 2), l < c.length && c[l][1].type === "content"))
      for (; ++l < c.length && c[l][1].type !== "content"; )
        c[l][1].type === "chunkText" && (c[l][1]._isInFirstContentOfListItem = !0, l++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, Ki(s, t)), t = n[t], u = !0);
    else if (r[1]._container) {
      for (l = t, i = void 0; l--; )
        if (o = s.get(l), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (s.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = l);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...s.get(i)[1].start
      }, a = s.slice(i, t), a.unshift(r), s.splice(i, t - i + 1, a));
    }
  }
  return se(e, 0, Number.POSITIVE_INFINITY, s.slice(0)), !u;
}
function Ki(e, n) {
  const t = e.get(n)[1], r = e.get(n)[2];
  let i = n - 1;
  const l = [];
  let o = t._tokenizer;
  o || (o = r.parser[t.contentType](t.start), t._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const a = o.events, c = [], u = {};
  let s, f, d = -1, p = t, w = 0, C = 0;
  const I = [C];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    l.push(i), p._tokenizer || (s = r.sliceStream(p), p.next || s.push(null), f && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(s), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = t; ++d < a.length; )
    // Find a void token that includes a break.
    a[d][0] === "exit" && a[d - 1][0] === "enter" && a[d][1].type === a[d - 1][1].type && a[d][1].start.line !== a[d][1].end.line && (C = d + 1, I.push(C), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : I.pop(), d = I.length; d--; ) {
    const k = a.slice(I[d], I[d + 1]), L = l.pop();
    c.push([L, L + k.length - 1]), e.splice(L, 2, k);
  }
  for (c.reverse(), d = -1; ++d < c.length; )
    u[w + c[d][0]] = w + c[d][1], w += c[d][1] - c[d][0] - 1;
  return u;
}
const Gi = {
  resolve: Zi,
  tokenize: el
}, Ji = {
  partial: !0,
  tokenize: nl
};
function Zi(e) {
  return Wt(e), e;
}
function el(e, n) {
  let t;
  return r;
  function r(a) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? l(a) : z(a) ? e.check(Ji, o, l)(a) : (e.consume(a), i);
  }
  function l(a) {
    return e.exit("chunkContent"), e.exit("content"), n(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function nl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), $(e, l, "linePrefix");
  }
  function l(o) {
    if (o === null || z(o))
      return t(o);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : e.interrupt(r.parser.constructs.flow, t, n)(o);
  }
}
function Yt(e, n, t, r, i, l, o, a, c) {
  const u = c || Number.POSITIVE_INFINITY;
  let s = 0;
  return f;
  function f(k) {
    return k === 60 ? (e.enter(r), e.enter(i), e.enter(l), e.consume(k), e.exit(l), d) : k === null || k === 32 || k === 41 || yn(k) ? t(k) : (e.enter(r), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), C(k));
  }
  function d(k) {
    return k === 62 ? (e.enter(l), e.consume(k), e.exit(l), e.exit(i), e.exit(r), n) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), p(k));
  }
  function p(k) {
    return k === 62 ? (e.exit("chunkString"), e.exit(a), d(k)) : k === null || k === 60 || z(k) ? t(k) : (e.consume(k), k === 92 ? w : p);
  }
  function w(k) {
    return k === 60 || k === 62 || k === 92 ? (e.consume(k), p) : p(k);
  }
  function C(k) {
    return !s && (k === null || k === 41 || G(k)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(r), n(k)) : s < u && k === 40 ? (e.consume(k), s++, C) : k === 41 ? (e.consume(k), s--, C) : k === null || k === 32 || k === 40 || yn(k) ? t(k) : (e.consume(k), k === 92 ? I : C);
  }
  function I(k) {
    return k === 40 || k === 41 || k === 92 ? (e.consume(k), C) : C(k);
  }
}
function Xt(e, n, t, r, i, l) {
  const o = this;
  let a = 0, c;
  return u;
  function u(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(l), s;
  }
  function s(p) {
    return a > 999 || p === null || p === 91 || p === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? t(p) : p === 93 ? (e.exit(l), e.enter(i), e.consume(p), e.exit(i), e.exit(r), n) : z(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), s) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || z(p) || a++ > 999 ? (e.exit("chunkString"), s(p)) : (e.consume(p), c || (c = !_(p)), p === 92 ? d : f);
  }
  function d(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), a++, f) : f(p);
  }
}
function Qt(e, n, t, r, i, l) {
  let o;
  return a;
  function a(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(r), e.enter(i), e.consume(d), e.exit(i), o = d === 40 ? 41 : d, c) : t(d);
  }
  function c(d) {
    return d === o ? (e.enter(i), e.consume(d), e.exit(i), e.exit(r), n) : (e.enter(l), u(d));
  }
  function u(d) {
    return d === o ? (e.exit(l), c(o)) : d === null ? t(d) : z(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), $(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), s(d));
  }
  function s(d) {
    return d === o || d === null || z(d) ? (e.exit("chunkString"), u(d)) : (e.consume(d), d === 92 ? f : s);
  }
  function f(d) {
    return d === o || d === 92 ? (e.consume(d), s) : s(d);
  }
}
function Me(e, n) {
  let t;
  return r;
  function r(i) {
    return z(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : _(i) ? $(e, r, t ? "linePrefix" : "lineSuffix")(i) : n(i);
  }
}
const tl = {
  name: "definition",
  tokenize: il
}, rl = {
  partial: !0,
  tokenize: ll
};
function il(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(p) {
    return e.enter("definition"), o(p);
  }
  function o(p) {
    return Xt.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function a(p) {
    return i = Te(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), c) : t(p);
  }
  function c(p) {
    return G(p) ? Me(e, u)(p) : u(p);
  }
  function u(p) {
    return Yt(
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function s(p) {
    return e.attempt(rl, f, f)(p);
  }
  function f(p) {
    return _(p) ? $(e, d, "whitespace")(p) : d(p);
  }
  function d(p) {
    return p === null || z(p) ? (e.exit("definition"), r.parser.defined.push(i), n(p)) : t(p);
  }
}
function ll(e, n, t) {
  return r;
  function r(a) {
    return G(a) ? Me(e, i)(a) : t(a);
  }
  function i(a) {
    return Qt(e, l, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function l(a) {
    return _(a) ? $(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || z(a) ? n(a) : t(a);
  }
}
const ol = {
  name: "hardBreakEscape",
  tokenize: al
};
function al(e, n, t) {
  return r;
  function r(l) {
    return e.enter("hardBreakEscape"), e.consume(l), i;
  }
  function i(l) {
    return z(l) ? (e.exit("hardBreakEscape"), n(l)) : t(l);
  }
}
const ul = {
  name: "headingAtx",
  resolve: sl,
  tokenize: cl
};
function sl(e, n) {
  let t = e.length - 2, r = 3, i, l;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, l = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, se(e, r, t - r + 1, [["enter", i, n], ["enter", l, n], ["exit", l, n], ["exit", i, n]])), e;
}
function cl(e, n, t) {
  let r = 0;
  return i;
  function i(s) {
    return e.enter("atxHeading"), l(s);
  }
  function l(s) {
    return e.enter("atxHeadingSequence"), o(s);
  }
  function o(s) {
    return s === 35 && r++ < 6 ? (e.consume(s), o) : s === null || G(s) ? (e.exit("atxHeadingSequence"), a(s)) : t(s);
  }
  function a(s) {
    return s === 35 ? (e.enter("atxHeadingSequence"), c(s)) : s === null || z(s) ? (e.exit("atxHeading"), n(s)) : _(s) ? $(e, a, "whitespace")(s) : (e.enter("atxHeadingText"), u(s));
  }
  function c(s) {
    return s === 35 ? (e.consume(s), c) : (e.exit("atxHeadingSequence"), a(s));
  }
  function u(s) {
    return s === null || s === 35 || G(s) ? (e.exit("atxHeadingText"), a(s)) : (e.consume(s), u);
  }
}
const pl = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ot = ["pre", "script", "style", "textarea"], fl = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: dl,
  tokenize: gl
}, hl = {
  partial: !0,
  tokenize: xl
}, ml = {
  partial: !0,
  tokenize: yl
};
function dl(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function gl(e, n, t) {
  const r = this;
  let i, l, o, a, c;
  return u;
  function u(m) {
    return s(m);
  }
  function s(m) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(m), f;
  }
  function f(m) {
    return m === 33 ? (e.consume(m), d) : m === 47 ? (e.consume(m), l = !0, C) : m === 63 ? (e.consume(m), i = 3, r.interrupt ? n : h) : ue(m) ? (e.consume(m), o = String.fromCharCode(m), I) : t(m);
  }
  function d(m) {
    return m === 45 ? (e.consume(m), i = 2, p) : m === 91 ? (e.consume(m), i = 5, a = 0, w) : ue(m) ? (e.consume(m), i = 4, r.interrupt ? n : h) : t(m);
  }
  function p(m) {
    return m === 45 ? (e.consume(m), r.interrupt ? n : h) : t(m);
  }
  function w(m) {
    const le = "CDATA[";
    return m === le.charCodeAt(a++) ? (e.consume(m), a === le.length ? r.interrupt ? n : T : w) : t(m);
  }
  function C(m) {
    return ue(m) ? (e.consume(m), o = String.fromCharCode(m), I) : t(m);
  }
  function I(m) {
    if (m === null || m === 47 || m === 62 || G(m)) {
      const le = m === 47, ye = o.toLowerCase();
      return !le && !l && ot.includes(ye) ? (i = 1, r.interrupt ? n(m) : T(m)) : pl.includes(o.toLowerCase()) ? (i = 6, le ? (e.consume(m), k) : r.interrupt ? n(m) : T(m)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(m) : l ? L(m) : E(m));
    }
    return m === 45 || ne(m) ? (e.consume(m), o += String.fromCharCode(m), I) : t(m);
  }
  function k(m) {
    return m === 62 ? (e.consume(m), r.interrupt ? n : T) : t(m);
  }
  function L(m) {
    return _(m) ? (e.consume(m), L) : N(m);
  }
  function E(m) {
    return m === 47 ? (e.consume(m), N) : m === 58 || m === 95 || ue(m) ? (e.consume(m), B) : _(m) ? (e.consume(m), E) : N(m);
  }
  function B(m) {
    return m === 45 || m === 46 || m === 58 || m === 95 || ne(m) ? (e.consume(m), B) : U(m);
  }
  function U(m) {
    return m === 61 ? (e.consume(m), y) : _(m) ? (e.consume(m), U) : E(m);
  }
  function y(m) {
    return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? t(m) : m === 34 || m === 39 ? (e.consume(m), c = m, F) : _(m) ? (e.consume(m), y) : V(m);
  }
  function F(m) {
    return m === c ? (e.consume(m), c = null, R) : m === null || z(m) ? t(m) : (e.consume(m), F);
  }
  function V(m) {
    return m === null || m === 34 || m === 39 || m === 47 || m === 60 || m === 61 || m === 62 || m === 96 || G(m) ? U(m) : (e.consume(m), V);
  }
  function R(m) {
    return m === 47 || m === 62 || _(m) ? E(m) : t(m);
  }
  function N(m) {
    return m === 62 ? (e.consume(m), P) : t(m);
  }
  function P(m) {
    return m === null || z(m) ? T(m) : _(m) ? (e.consume(m), P) : t(m);
  }
  function T(m) {
    return m === 45 && i === 2 ? (e.consume(m), M) : m === 60 && i === 1 ? (e.consume(m), Y) : m === 62 && i === 4 ? (e.consume(m), ie) : m === 63 && i === 3 ? (e.consume(m), h) : m === 93 && i === 5 ? (e.consume(m), ce) : z(m) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(hl, pe, q)(m)) : m === null || z(m) ? (e.exit("htmlFlowData"), q(m)) : (e.consume(m), T);
  }
  function q(m) {
    return e.check(ml, A, pe)(m);
  }
  function A(m) {
    return e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), S;
  }
  function S(m) {
    return m === null || z(m) ? q(m) : (e.enter("htmlFlowData"), T(m));
  }
  function M(m) {
    return m === 45 ? (e.consume(m), h) : T(m);
  }
  function Y(m) {
    return m === 47 ? (e.consume(m), o = "", re) : T(m);
  }
  function re(m) {
    if (m === 62) {
      const le = o.toLowerCase();
      return ot.includes(le) ? (e.consume(m), ie) : T(m);
    }
    return ue(m) && o.length < 8 ? (e.consume(m), o += String.fromCharCode(m), re) : T(m);
  }
  function ce(m) {
    return m === 93 ? (e.consume(m), h) : T(m);
  }
  function h(m) {
    return m === 62 ? (e.consume(m), ie) : m === 45 && i === 2 ? (e.consume(m), h) : T(m);
  }
  function ie(m) {
    return m === null || z(m) ? (e.exit("htmlFlowData"), pe(m)) : (e.consume(m), ie);
  }
  function pe(m) {
    return e.exit("htmlFlow"), n(m);
  }
}
function yl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return z(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l) : t(o);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
function xl(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ke, n, t);
  }
}
const kl = {
  name: "htmlText",
  tokenize: bl
};
function bl(e, n, t) {
  const r = this;
  let i, l, o;
  return a;
  function a(h) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(h), c;
  }
  function c(h) {
    return h === 33 ? (e.consume(h), u) : h === 47 ? (e.consume(h), U) : h === 63 ? (e.consume(h), E) : ue(h) ? (e.consume(h), V) : t(h);
  }
  function u(h) {
    return h === 45 ? (e.consume(h), s) : h === 91 ? (e.consume(h), l = 0, w) : ue(h) ? (e.consume(h), L) : t(h);
  }
  function s(h) {
    return h === 45 ? (e.consume(h), p) : t(h);
  }
  function f(h) {
    return h === null ? t(h) : h === 45 ? (e.consume(h), d) : z(h) ? (o = f, Y(h)) : (e.consume(h), f);
  }
  function d(h) {
    return h === 45 ? (e.consume(h), p) : f(h);
  }
  function p(h) {
    return h === 62 ? M(h) : h === 45 ? d(h) : f(h);
  }
  function w(h) {
    const ie = "CDATA[";
    return h === ie.charCodeAt(l++) ? (e.consume(h), l === ie.length ? C : w) : t(h);
  }
  function C(h) {
    return h === null ? t(h) : h === 93 ? (e.consume(h), I) : z(h) ? (o = C, Y(h)) : (e.consume(h), C);
  }
  function I(h) {
    return h === 93 ? (e.consume(h), k) : C(h);
  }
  function k(h) {
    return h === 62 ? M(h) : h === 93 ? (e.consume(h), k) : C(h);
  }
  function L(h) {
    return h === null || h === 62 ? M(h) : z(h) ? (o = L, Y(h)) : (e.consume(h), L);
  }
  function E(h) {
    return h === null ? t(h) : h === 63 ? (e.consume(h), B) : z(h) ? (o = E, Y(h)) : (e.consume(h), E);
  }
  function B(h) {
    return h === 62 ? M(h) : E(h);
  }
  function U(h) {
    return ue(h) ? (e.consume(h), y) : t(h);
  }
  function y(h) {
    return h === 45 || ne(h) ? (e.consume(h), y) : F(h);
  }
  function F(h) {
    return z(h) ? (o = F, Y(h)) : _(h) ? (e.consume(h), F) : M(h);
  }
  function V(h) {
    return h === 45 || ne(h) ? (e.consume(h), V) : h === 47 || h === 62 || G(h) ? R(h) : t(h);
  }
  function R(h) {
    return h === 47 ? (e.consume(h), M) : h === 58 || h === 95 || ue(h) ? (e.consume(h), N) : z(h) ? (o = R, Y(h)) : _(h) ? (e.consume(h), R) : M(h);
  }
  function N(h) {
    return h === 45 || h === 46 || h === 58 || h === 95 || ne(h) ? (e.consume(h), N) : P(h);
  }
  function P(h) {
    return h === 61 ? (e.consume(h), T) : z(h) ? (o = P, Y(h)) : _(h) ? (e.consume(h), P) : R(h);
  }
  function T(h) {
    return h === null || h === 60 || h === 61 || h === 62 || h === 96 ? t(h) : h === 34 || h === 39 ? (e.consume(h), i = h, q) : z(h) ? (o = T, Y(h)) : _(h) ? (e.consume(h), T) : (e.consume(h), A);
  }
  function q(h) {
    return h === i ? (e.consume(h), i = void 0, S) : h === null ? t(h) : z(h) ? (o = q, Y(h)) : (e.consume(h), q);
  }
  function A(h) {
    return h === null || h === 34 || h === 39 || h === 60 || h === 61 || h === 96 ? t(h) : h === 47 || h === 62 || G(h) ? R(h) : (e.consume(h), A);
  }
  function S(h) {
    return h === 47 || h === 62 || G(h) ? R(h) : t(h);
  }
  function M(h) {
    return h === 62 ? (e.consume(h), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(h);
  }
  function Y(h) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), re;
  }
  function re(h) {
    return _(h) ? $(e, ce, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(h) : ce(h);
  }
  function ce(h) {
    return e.enter("htmlTextData"), o(h);
  }
}
const vn = {
  name: "labelEnd",
  resolveAll: El,
  resolveTo: Il,
  tokenize: Tl
}, wl = {
  tokenize: Pl
}, Sl = {
  tokenize: Al
}, Cl = {
  tokenize: zl
};
function El(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const r = e[n][1];
    if (t.push(e[n]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", n += i;
    }
  }
  return e.length !== t.length && se(e, 0, e.length, t), e;
}
function Il(e, n) {
  let t = e.length, r = 0, i, l, o, a;
  for (; t--; )
    if (i = e[t][1], l) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (l = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = t);
  const c = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, s = {
    type: "labelText",
    start: {
      ...e[l + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return a = [["enter", c, n], ["enter", u, n]], a = te(a, e.slice(l + 1, l + r + 3)), a = te(a, [["enter", s, n]]), a = te(a, Ln(n.parser.constructs.insideSpan.null, e.slice(l + r + 4, o - 3), n)), a = te(a, [["exit", s, n], e[o - 2], e[o - 1], ["exit", u, n]]), a = te(a, e.slice(o + 1)), a = te(a, [["exit", c, n]]), se(e, l, e.length, a), e;
}
function Tl(e, n, t) {
  const r = this;
  let i = r.events.length, l, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      l = r.events[i][1];
      break;
    }
  return a;
  function a(d) {
    return l ? l._inactive ? f(d) : (o = r.parser.defined.includes(Te(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), c) : t(d);
  }
  function c(d) {
    return d === 40 ? e.attempt(wl, s, o ? s : f)(d) : d === 91 ? e.attempt(Sl, s, o ? u : f)(d) : o ? s(d) : f(d);
  }
  function u(d) {
    return e.attempt(Cl, s, f)(d);
  }
  function s(d) {
    return n(d);
  }
  function f(d) {
    return l._balanced = !0, t(d);
  }
}
function Pl(e, n, t) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return G(f) ? Me(e, l)(f) : l(f);
  }
  function l(f) {
    return f === 41 ? s(f) : Yt(e, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return G(f) ? Me(e, c)(f) : s(f);
  }
  function a(f) {
    return t(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? Qt(e, u, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : s(f);
  }
  function u(f) {
    return G(f) ? Me(e, s)(f) : s(f);
  }
  function s(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : t(f);
  }
}
function Al(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return Xt.call(r, e, l, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function l(a) {
    return r.parser.defined.includes(Te(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? n(a) : t(a);
  }
  function o(a) {
    return t(a);
  }
}
function zl(e, n, t) {
  return r;
  function r(l) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), i;
  }
  function i(l) {
    return l === 93 ? (e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), e.exit("reference"), n) : t(l);
  }
}
const Ll = {
  name: "labelStartImage",
  resolveAll: vn.resolveAll,
  tokenize: vl
};
function vl(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : t(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(a) : n(a);
  }
}
const Dl = {
  name: "labelStartLink",
  resolveAll: vn.resolveAll,
  tokenize: Ol
};
function Ol(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), l;
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const rn = {
  name: "lineEnding",
  tokenize: Fl
};
function Fl(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), $(e, n, "linePrefix");
  }
}
const Ye = {
  name: "thematicBreak",
  tokenize: _l
};
function _l(e, n, t) {
  let r = 0, i;
  return l;
  function l(u) {
    return e.enter("thematicBreak"), o(u);
  }
  function o(u) {
    return i = u, a(u);
  }
  function a(u) {
    return u === i ? (e.enter("thematicBreakSequence"), c(u)) : r >= 3 && (u === null || z(u)) ? (e.exit("thematicBreak"), n(u)) : t(u);
  }
  function c(u) {
    return u === i ? (e.consume(u), r++, c) : (e.exit("thematicBreakSequence"), _(u) ? $(e, a, "whitespace")(u) : a(u));
  }
}
const K = {
  continuation: {
    tokenize: Bl
  },
  exit: Hl,
  name: "list",
  tokenize: Ml
}, Rl = {
  partial: !0,
  tokenize: Ul
}, Nl = {
  partial: !0,
  tokenize: jl
};
function Ml(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let l = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(p) {
    const w = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (w === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : xn(p)) {
      if (r.containerState.type || (r.containerState.type = w, e.enter(w, {
        _container: !0
      })), w === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(Ye, t, u)(p) : u(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(p);
    }
    return t(p);
  }
  function c(p) {
    return xn(p) && ++o < 10 ? (e.consume(p), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), u(p)) : t(p);
  }
  function u(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Ke,
      // Can’t be empty when interrupting.
      r.interrupt ? t : s,
      e.attempt(Rl, d, f)
    );
  }
  function s(p) {
    return r.containerState.initialBlankLine = !0, l++, d(p);
  }
  function f(p) {
    return _(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), d) : t(p);
  }
  function d(p) {
    return r.containerState.size = l + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(p);
  }
}
function Bl(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ke, i, l);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, $(e, n, "listItemIndent", r.containerState.size + 1)(a);
  }
  function l(a) {
    return r.containerState.furtherBlankLines || !_(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Nl, n, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, $(e, e.attempt(K, n, t), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function jl(e, n, t) {
  const r = this;
  return $(e, i, "listItemIndent", r.containerState.size + 1);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? n(l) : t(l);
  }
}
function Hl(e) {
  e.exit(this.containerState.type);
}
function Ul(e, n, t) {
  const r = this;
  return $(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return !_(l) && o && o[1].type === "listItemPrefixWhitespace" ? n(l) : t(l);
  }
}
const at = {
  name: "setextUnderline",
  resolveTo: Vl,
  tokenize: ql
};
function Vl(e, n) {
  let t = e.length, r, i, l;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !l && e[t][1].type === "definition" && (l = t);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", l ? (e.splice(i, 0, ["enter", o, n]), e.splice(l + 1, 0, ["exit", e[r][1], n]), e[r][1].end = {
    ...e[l][1].end
  }) : e[r][1] = o, e.push(["exit", o, n]), e;
}
function ql(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(u) {
    let s = r.events.length, f;
    for (; s--; )
      if (r.events[s][1].type !== "lineEnding" && r.events[s][1].type !== "linePrefix" && r.events[s][1].type !== "content") {
        f = r.events[s][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = u, o(u)) : t(u);
  }
  function o(u) {
    return e.enter("setextHeadingLineSequence"), a(u);
  }
  function a(u) {
    return u === i ? (e.consume(u), a) : (e.exit("setextHeadingLineSequence"), _(u) ? $(e, c, "lineSuffix")(u) : c(u));
  }
  function c(u) {
    return u === null || z(u) ? (e.exit("setextHeadingLine"), n(u)) : t(u);
  }
}
const $l = {
  tokenize: Wl
};
function Wl(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Ke,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, $(e, e.attempt(this.parser.constructs.flow, i, e.attempt(Gi, i)), "linePrefix"))
  );
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(l), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const Yl = {
  resolveAll: Gt()
}, Xl = Kt("string"), Ql = Kt("text");
function Kt(e) {
  return {
    resolveAll: Gt(e === "text" ? Kl : void 0),
    tokenize: n
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], l = t.attempt(i, o, a);
    return o;
    function o(s) {
      return u(s) ? l(s) : a(s);
    }
    function a(s) {
      if (s === null) {
        t.consume(s);
        return;
      }
      return t.enter("data"), t.consume(s), c;
    }
    function c(s) {
      return u(s) ? (t.exit("data"), l(s)) : (t.consume(s), c);
    }
    function u(s) {
      if (s === null)
        return !0;
      const f = i[s];
      let d = -1;
      if (f)
        for (; ++d < f.length; ) {
          const p = f[d];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Gt(e) {
  return n;
  function n(t, r) {
    let i = -1, l;
    for (; ++i <= t.length; )
      l === void 0 ? t[i] && t[i][1].type === "data" && (l = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== l + 2 && (t[l][1].end = t[i - 1][1].end, t.splice(l + 2, i - l - 2), i = l + 2), l = void 0);
    return e ? e(t, r) : t;
  }
}
function Kl(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let l = i.length, o = -1, a = 0, c;
      for (; l--; ) {
        const u = i[l];
        if (typeof u == "string") {
          for (o = u.length; u.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (u === -2)
          c = !0, a++;
        else if (u !== -1) {
          l++;
          break;
        }
      }
      if (n._contentTypeTextTrailing && t === e.length && (a = 0), a) {
        const u = {
          type: t === e.length || c || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: l ? o : r.start._bufferIndex + o,
            _index: r.start._index + l,
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...u.start
        }, r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(t, 0, ["enter", u, n], ["exit", u, n]), t += 2);
      }
      t++;
    }
  return e;
}
const Gl = {
  42: K,
  43: K,
  45: K,
  48: K,
  49: K,
  50: K,
  51: K,
  52: K,
  53: K,
  54: K,
  55: K,
  56: K,
  57: K,
  62: Vt
}, Jl = {
  91: tl
}, Zl = {
  [-2]: tn,
  [-1]: tn,
  32: tn
}, eo = {
  35: ul,
  42: Ye,
  45: [at, Ye],
  60: fl,
  61: at,
  95: Ye,
  96: lt,
  126: lt
}, no = {
  38: $t,
  92: qt
}, to = {
  [-5]: rn,
  [-4]: rn,
  [-3]: rn,
  33: Ll,
  38: $t,
  42: kn,
  60: [Di, kl],
  91: Dl,
  92: [ol, qt],
  93: vn,
  95: kn,
  96: $i
}, ro = {
  null: [kn, Yl]
}, io = {
  null: [42, 95]
}, lo = {
  null: []
}, oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: io,
  contentInitial: Jl,
  disable: lo,
  document: Gl,
  flow: eo,
  flowInitial: Zl,
  insideSpan: ro,
  string: no,
  text: to
}, Symbol.toStringTag, { value: "Module" }));
function ao(e, n, t) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const i = {}, l = [];
  let o = [], a = [];
  const c = {
    attempt: F(U),
    check: F(y),
    consume: L,
    enter: E,
    exit: B,
    interrupt: F(y, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: w,
    parser: e,
    previous: null,
    sliceSerialize: d,
    sliceStream: p,
    write: f
  };
  let s = n.tokenize.call(u, c);
  return n.resolveAll && l.push(n), u;
  function f(P) {
    return o = te(o, P), I(), o[o.length - 1] !== null ? [] : (V(n, 0), u.events = Ln(l, u.events, u), u.events);
  }
  function d(P, T) {
    return so(p(P), T);
  }
  function p(P) {
    return uo(o, P);
  }
  function w() {
    const {
      _bufferIndex: P,
      _index: T,
      line: q,
      column: A,
      offset: S
    } = r;
    return {
      _bufferIndex: P,
      _index: T,
      line: q,
      column: A,
      offset: S
    };
  }
  function C(P) {
    i[P.line] = P.column, N();
  }
  function I() {
    let P;
    for (; r._index < o.length; ) {
      const T = o[r._index];
      if (typeof T == "string")
        for (P = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === P && r._bufferIndex < T.length; )
          k(T.charCodeAt(r._bufferIndex));
      else
        k(T);
    }
  }
  function k(P) {
    s = s(P);
  }
  function L(P) {
    z(P) ? (r.line++, r.column = 1, r.offset += P === -3 ? 2 : 1, N()) : P !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = P;
  }
  function E(P, T) {
    const q = T || {};
    return q.type = P, q.start = w(), u.events.push(["enter", q, u]), a.push(q), q;
  }
  function B(P) {
    const T = a.pop();
    return T.end = w(), u.events.push(["exit", T, u]), T;
  }
  function U(P, T) {
    V(P, T.from);
  }
  function y(P, T) {
    T.restore();
  }
  function F(P, T) {
    return q;
    function q(A, S, M) {
      let Y, re, ce, h;
      return Array.isArray(A) ? (
        /* c8 ignore next 1 */
        pe(A)
      ) : "tokenize" in A ? (
        // Looks like a construct.
        pe([
          /** @type {Construct} */
          A
        ])
      ) : ie(A);
      function ie(X) {
        return Le;
        function Le(me) {
          const we = me !== null && X[me], Se = me !== null && X.null, Ve = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(we) ? we : we ? [we] : [],
            ...Array.isArray(Se) ? Se : Se ? [Se] : []
          ];
          return pe(Ve)(me);
        }
      }
      function pe(X) {
        return Y = X, re = 0, X.length === 0 ? M : m(X[re]);
      }
      function m(X) {
        return Le;
        function Le(me) {
          return h = R(), ce = X, X.partial || (u.currentConstruct = X), X.name && u.parser.constructs.disable.null.includes(X.name) ? ye() : X.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            T ? Object.assign(Object.create(u), T) : u,
            c,
            le,
            ye
          )(me);
        }
      }
      function le(X) {
        return P(ce, h), S;
      }
      function ye(X) {
        return h.restore(), ++re < Y.length ? m(Y[re]) : M;
      }
    }
  }
  function V(P, T) {
    P.resolveAll && !l.includes(P) && l.push(P), P.resolve && se(u.events, T, u.events.length - T, P.resolve(u.events.slice(T), u)), P.resolveTo && (u.events = P.resolveTo(u.events, u));
  }
  function R() {
    const P = w(), T = u.previous, q = u.currentConstruct, A = u.events.length, S = Array.from(a);
    return {
      from: A,
      restore: M
    };
    function M() {
      r = P, u.previous = T, u.currentConstruct = q, u.events.length = A, a = S, N();
    }
  }
  function N() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function uo(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, l = n.end._bufferIndex;
  let o;
  if (t === i)
    o = [e[t].slice(r, l)];
  else {
    if (o = e.slice(t, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    l > 0 && o.push(e[i].slice(0, l));
  }
  return o;
}
function so(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const l = e[t];
    let o;
    if (typeof l == "string")
      o = l;
    else switch (l) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(l);
    }
    i = l === -2, r.push(o);
  }
  return r.join("");
}
function co(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      yi([oo, ...(e || {}).extensions || []])
    ),
    content: i(Ii),
    defined: [],
    document: i(Pi),
    flow: i($l),
    lazy: {},
    string: i(Xl),
    text: i(Ql)
  };
  return r;
  function i(l) {
    return o;
    function o(a) {
      return ao(r, l, a);
    }
  }
}
function po(e) {
  for (; !Wt(e); )
    ;
  return e;
}
const ut = /[\0\t\n\r]/g;
function fo() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(l, o, a) {
    const c = [];
    let u, s, f, d, p;
    for (l = n + (typeof l == "string" ? l.toString() : new TextDecoder(o || void 0).decode(l)), f = 0, n = "", t && (l.charCodeAt(0) === 65279 && f++, t = void 0); f < l.length; ) {
      if (ut.lastIndex = f, u = ut.exec(l), d = u && u.index !== void 0 ? u.index : l.length, p = l.charCodeAt(d), !u) {
        n = l.slice(f);
        break;
      }
      if (p === 10 && f === d && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), f < d && (c.push(l.slice(f, d)), e += d - f), p) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (s = Math.ceil(e / 4) * 4, c.push(-2); e++ < s; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = d + 1;
    }
    return a && (r && c.push(-5), n && c.push(n), c.push(null)), c;
  }
}
const ho = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function mo(e) {
  return e.replace(ho, go);
}
function go(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), l = i === 120 || i === 88;
    return Ut(t.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return zn(t) || e;
}
const Jt = {}.hasOwnProperty;
function yo(e, n, t) {
  return n && typeof n == "object" && (t = n, n = void 0), xo(t)(po(co(t).document().write(fo()(e, n, !0))));
}
function xo(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(jn),
      autolinkProtocol: R,
      autolinkEmail: R,
      atxHeading: l(Nn),
      blockQuote: l(Se),
      characterEscape: R,
      characterReference: R,
      codeFenced: l(Ve),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: l(Ve, o),
      codeText: l(sr, o),
      codeTextData: R,
      data: R,
      codeFlowValue: R,
      definition: l(cr),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: l(pr),
      hardBreakEscape: l(Mn),
      hardBreakTrailing: l(Mn),
      htmlFlow: l(Bn, o),
      htmlFlowData: R,
      htmlText: l(Bn, o),
      htmlTextData: R,
      image: l(fr),
      label: o,
      link: l(jn),
      listItem: l(hr),
      listItemValue: d,
      listOrdered: l(Hn, f),
      listUnordered: l(Hn),
      paragraph: l(mr),
      reference: m,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: l(Nn),
      strong: l(dr),
      thematicBreak: l(yr)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: U,
      autolink: c(),
      autolinkEmail: we,
      autolinkProtocol: me,
      blockQuote: c(),
      characterEscapeValue: N,
      characterReferenceMarkerHexadecimal: ye,
      characterReferenceMarkerNumeric: ye,
      characterReferenceValue: X,
      characterReference: Le,
      codeFenced: c(I),
      codeFencedFence: C,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: w,
      codeFlowValue: N,
      codeIndented: c(k),
      codeText: c(S),
      codeTextData: N,
      data: N,
      definition: c(),
      definitionDestinationString: B,
      definitionLabelString: L,
      definitionTitleString: E,
      emphasis: c(),
      hardBreakEscape: c(T),
      hardBreakTrailing: c(T),
      htmlFlow: c(q),
      htmlFlowData: N,
      htmlText: c(A),
      htmlTextData: N,
      image: c(Y),
      label: ce,
      labelText: re,
      lineEnding: P,
      link: c(M),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: le,
      resourceDestinationString: h,
      resourceTitleString: ie,
      resource: pe,
      setextHeading: c(V),
      setextHeadingLineSequence: F,
      setextHeadingText: y,
      strong: c(),
      thematicBreak: c()
    }
  };
  Zt(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(g) {
    let b = {
      type: "root",
      children: []
    };
    const D = {
      stack: [b],
      tokenStack: [],
      config: n,
      enter: a,
      exit: u,
      buffer: o,
      resume: s,
      data: t
    }, O = [];
    let j = -1;
    for (; ++j < g.length; )
      if (g[j][1].type === "listOrdered" || g[j][1].type === "listUnordered")
        if (g[j][0] === "enter")
          O.push(j);
        else {
          const oe = O.pop();
          j = i(g, oe, j);
        }
    for (j = -1; ++j < g.length; ) {
      const oe = n[g[j][0]];
      Jt.call(oe, g[j][1].type) && oe[g[j][1].type].call(Object.assign({
        sliceSerialize: g[j][2].sliceSerialize
      }, D), g[j][1]);
    }
    if (D.tokenStack.length > 0) {
      const oe = D.tokenStack[D.tokenStack.length - 1];
      (oe[1] || st).call(D, void 0, oe[0]);
    }
    for (b.position = {
      start: de(g.length > 0 ? g[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: de(g.length > 0 ? g[g.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, j = -1; ++j < n.transforms.length; )
      b = n.transforms[j](b) || b;
    return b;
  }
  function i(g, b, D) {
    let O = b - 1, j = -1, oe = !1, xe, fe, ve, De;
    for (; ++O <= D; ) {
      const Z = g[O];
      switch (Z[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Z[0] === "enter" ? j++ : j--, De = void 0;
          break;
        }
        case "lineEndingBlank": {
          Z[0] === "enter" && (xe && !De && !j && !ve && (ve = O), De = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          De = void 0;
      }
      if (!j && Z[0] === "enter" && Z[1].type === "listItemPrefix" || j === -1 && Z[0] === "exit" && (Z[1].type === "listUnordered" || Z[1].type === "listOrdered")) {
        if (xe) {
          let Ce = O;
          for (fe = void 0; Ce--; ) {
            const he = g[Ce];
            if (he[1].type === "lineEnding" || he[1].type === "lineEndingBlank") {
              if (he[0] === "exit") continue;
              fe && (g[fe][1].type = "lineEndingBlank", oe = !0), he[1].type = "lineEnding", fe = Ce;
            } else if (!(he[1].type === "linePrefix" || he[1].type === "blockQuotePrefix" || he[1].type === "blockQuotePrefixWhitespace" || he[1].type === "blockQuoteMarker" || he[1].type === "listItemIndent")) break;
          }
          ve && (!fe || ve < fe) && (xe._spread = !0), xe.end = Object.assign({}, fe ? g[fe][1].start : Z[1].end), g.splice(fe || O, 0, ["exit", xe, Z[2]]), O++, D++;
        }
        if (Z[1].type === "listItemPrefix") {
          const Ce = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Z[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          xe = Ce, g.splice(O, 0, ["enter", Ce, Z[2]]), O++, D++, ve = void 0, De = !0;
        }
      }
    }
    return g[b][1]._spread = oe, D;
  }
  function l(g, b) {
    return D;
    function D(O) {
      a.call(this, g(O), O), b && b.call(this, O);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(g, b, D) {
    this.stack[this.stack.length - 1].children.push(g), this.stack.push(g), this.tokenStack.push([b, D || void 0]), g.position = {
      start: de(b.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(g) {
    return b;
    function b(D) {
      g && g.call(this, D), u.call(this, D);
    }
  }
  function u(g, b) {
    const D = this.stack.pop(), O = this.tokenStack.pop();
    if (O)
      O[0].type !== g.type && (b ? b.call(this, g, O[0]) : (O[1] || st).call(this, g, O[0]));
    else throw new Error("Cannot close `" + g.type + "` (" + Ne({
      start: g.start,
      end: g.end
    }) + "): it’s not open");
    D.position.end = de(g.end);
  }
  function s() {
    return di(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(g) {
    if (this.data.expectingFirstListItemValue) {
      const b = this.stack[this.stack.length - 2];
      b.start = Number.parseInt(this.sliceSerialize(g), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.lang = g;
  }
  function w() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.meta = g;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function I() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.value = g.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function k() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.value = g.replace(/(\r?\n|\r)$/g, "");
  }
  function L(g) {
    const b = this.resume(), D = this.stack[this.stack.length - 1];
    D.label = b, D.identifier = Te(this.sliceSerialize(g)).toLowerCase();
  }
  function E() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.title = g;
  }
  function B() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.url = g;
  }
  function U(g) {
    const b = this.stack[this.stack.length - 1];
    if (!b.depth) {
      const D = this.sliceSerialize(g).length;
      b.depth = D;
    }
  }
  function y() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function F(g) {
    const b = this.stack[this.stack.length - 1];
    b.depth = this.sliceSerialize(g).codePointAt(0) === 61 ? 1 : 2;
  }
  function V() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function R(g) {
    const D = this.stack[this.stack.length - 1].children;
    let O = D[D.length - 1];
    (!O || O.type !== "text") && (O = gr(), O.position = {
      start: de(g.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, D.push(O)), this.stack.push(O);
  }
  function N(g) {
    const b = this.stack.pop();
    b.value += this.sliceSerialize(g), b.position.end = de(g.end);
  }
  function P(g) {
    const b = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const D = b.children[b.children.length - 1];
      D.position.end = de(g.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(b.type) && (R.call(this, g), N.call(this, g));
  }
  function T() {
    this.data.atHardBreak = !0;
  }
  function q() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.value = g;
  }
  function A() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.value = g;
  }
  function S() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.value = g;
  }
  function M() {
    const g = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const b = this.data.referenceType || "shortcut";
      g.type += "Reference", g.referenceType = b, delete g.url, delete g.title;
    } else
      delete g.identifier, delete g.label;
    this.data.referenceType = void 0;
  }
  function Y() {
    const g = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const b = this.data.referenceType || "shortcut";
      g.type += "Reference", g.referenceType = b, delete g.url, delete g.title;
    } else
      delete g.identifier, delete g.label;
    this.data.referenceType = void 0;
  }
  function re(g) {
    const b = this.sliceSerialize(g), D = this.stack[this.stack.length - 2];
    D.label = mo(b), D.identifier = Te(b).toLowerCase();
  }
  function ce() {
    const g = this.stack[this.stack.length - 1], b = this.resume(), D = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, D.type === "link") {
      const O = g.children;
      D.children = O;
    } else
      D.alt = b;
  }
  function h() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.url = g;
  }
  function ie() {
    const g = this.resume(), b = this.stack[this.stack.length - 1];
    b.title = g;
  }
  function pe() {
    this.data.inReference = void 0;
  }
  function m() {
    this.data.referenceType = "collapsed";
  }
  function le(g) {
    const b = this.resume(), D = this.stack[this.stack.length - 1];
    D.label = b, D.identifier = Te(this.sliceSerialize(g)).toLowerCase(), this.data.referenceType = "full";
  }
  function ye(g) {
    this.data.characterReferenceType = g.type;
  }
  function X(g) {
    const b = this.sliceSerialize(g), D = this.data.characterReferenceType;
    let O;
    D ? (O = Ut(b, D === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : O = zn(b);
    const j = this.stack[this.stack.length - 1];
    j.value += O;
  }
  function Le(g) {
    const b = this.stack.pop();
    b.position.end = de(g.end);
  }
  function me(g) {
    N.call(this, g);
    const b = this.stack[this.stack.length - 1];
    b.url = this.sliceSerialize(g);
  }
  function we(g) {
    N.call(this, g);
    const b = this.stack[this.stack.length - 1];
    b.url = "mailto:" + this.sliceSerialize(g);
  }
  function Se() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ve() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function sr() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function cr() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function pr() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Nn() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Mn() {
    return {
      type: "break"
    };
  }
  function Bn() {
    return {
      type: "html",
      value: ""
    };
  }
  function fr() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function jn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Hn(g) {
    return {
      type: "list",
      ordered: g.type === "listOrdered",
      start: null,
      spread: g._spread,
      children: []
    };
  }
  function hr(g) {
    return {
      type: "listItem",
      spread: g._spread,
      checked: null,
      children: []
    };
  }
  function mr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function dr() {
    return {
      type: "strong",
      children: []
    };
  }
  function gr() {
    return {
      type: "text",
      value: ""
    };
  }
  function yr() {
    return {
      type: "thematicBreak"
    };
  }
}
function de(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Zt(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? Zt(e, r) : ko(e, r);
  }
}
function ko(e, n) {
  let t;
  for (t in n)
    if (Jt.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function st(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ne({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ne({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ne({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function bo(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return yo(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function wo(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function So(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function Co(e, n) {
  const t = n.value ? n.value + `
` : "", r = {}, i = n.lang ? n.lang.split(/\s+/) : [];
  i.length > 0 && (r.className = ["language-" + i[0]]);
  let l = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (l.data = { meta: n.meta }), e.patch(n, l), l = e.applyData(n, l), l = { type: "element", tagName: "pre", properties: {}, children: [l] }, e.patch(n, l), l;
}
function Eo(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Io(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function To(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = ze(r.toLowerCase()), l = e.footnoteOrder.indexOf(r);
  let o, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = l + 1, a += 1, e.footnoteCounts.set(r, a);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, c);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(n, u), e.applyData(n, u);
}
function Po(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ao(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function er(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), l = i[0];
  l && l.type === "text" ? l.value = "[" + l.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function zo(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return er(e, n);
  const i = { src: ze(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, l), e.applyData(n, l);
}
function Lo(e, n) {
  const t = { src: ze(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function vo(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function Do(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return er(e, n);
  const i = { href: ze(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function Oo(e, n) {
  const t = { href: ze(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function Fo(e, n, t) {
  const r = e.all(n), i = t ? _o(t) : nr(n), l = {}, o = [];
  if (typeof n.checked == "boolean") {
    const s = r[0];
    let f;
    s && s.type === "element" && s.tagName === "p" ? f = s : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), l.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const s = r[a];
    (i || a !== 0 || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` }), s.type === "element" && s.tagName === "p" && !i ? o.push(...s.children) : o.push(s);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: l, children: o };
  return e.patch(n, u), e.applyData(n, u);
}
function _o(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = nr(t[r]);
  }
  return n;
}
function nr(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function Ro(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const l = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function No(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Mo(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function Bo(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function jo(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], o), i.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, a = In(n.children[1]), c = _t(n.children[n.children.length - 1]);
    a && c && (o.position = { start: a, end: c }), i.push(o);
  }
  const l = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function Ho(e, n, t) {
  const r = t ? t.children : void 0, l = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, a = o ? o.length : n.children.length;
  let c = -1;
  const u = [];
  for (; ++c < a; ) {
    const f = n.children[c], d = {}, p = o ? o[c] : void 0;
    p && (d.align = p);
    let w = { type: "element", tagName: l, properties: d, children: [] };
    f && (w.children = e.all(f), e.patch(f, w), w = e.applyData(f, w)), u.push(w);
  }
  const s = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(n, s), e.applyData(n, s);
}
function Uo(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const ct = 9, pt = 32;
function Vo(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const l = [];
  for (; r; )
    l.push(
      ft(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return l.push(ft(n.slice(i), i > 0, !1)), l.join("");
}
function ft(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let l = e.codePointAt(r);
    for (; l === ct || l === pt; )
      r++, l = e.codePointAt(r);
  }
  if (t) {
    let l = e.codePointAt(i - 1);
    for (; l === ct || l === pt; )
      i--, l = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function qo(e, n) {
  const t = { type: "text", value: Vo(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function $o(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Wo = {
  blockquote: wo,
  break: So,
  code: Co,
  delete: Eo,
  emphasis: Io,
  footnoteReference: To,
  heading: Po,
  html: Ao,
  imageReference: zo,
  image: Lo,
  inlineCode: vo,
  linkReference: Do,
  link: Oo,
  listItem: Fo,
  list: Ro,
  paragraph: No,
  // @ts-expect-error: root is different, but hard to type.
  root: Mo,
  strong: Bo,
  table: jo,
  tableCell: Uo,
  tableRow: Ho,
  text: qo,
  thematicBreak: $o,
  toml: qe,
  yaml: qe,
  definition: qe,
  footnoteDefinition: qe
};
function qe() {
}
const tr = -1, Ge = 0, Be = 1, Xe = 2, Dn = 3, On = 4, Fn = 5, _n = 6, rr = 7, ir = 8, Yo = typeof self == "object" ? self : globalThis, ht = (e, n) => {
  switch (e) {
    case "Function":
    case "SharedWorker":
    case "Worker":
    case "eval":
    case "setInterval":
    case "setTimeout":
      throw new TypeError("unable to deserialize " + e);
  }
  return new Yo[e](n);
}, Xo = (e, n) => {
  const t = (i, l) => (e.set(l, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [l, o] = n[i];
    switch (l) {
      case Ge:
      case tr:
        return t(o, i);
      case Be: {
        const a = t([], i);
        for (const c of o)
          a.push(r(c));
        return a;
      }
      case Xe: {
        const a = t({}, i);
        for (const [c, u] of o)
          a[r(c)] = r(u);
        return a;
      }
      case Dn:
        return t(new Date(o), i);
      case On: {
        const { source: a, flags: c } = o;
        return t(new RegExp(a, c), i);
      }
      case Fn: {
        const a = t(/* @__PURE__ */ new Map(), i);
        for (const [c, u] of o)
          a.set(r(c), r(u));
        return a;
      }
      case _n: {
        const a = t(/* @__PURE__ */ new Set(), i);
        for (const c of o)
          a.add(r(c));
        return a;
      }
      case rr: {
        const { name: a, message: c } = o;
        return t(ht(a, c), i);
      }
      case ir:
        return t(BigInt(o), i);
      case "BigInt":
        return t(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return t(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: a } = new Uint8Array(o);
        return t(new DataView(a), o);
      }
    }
    return t(ht(l, o), i);
  };
  return r;
}, mt = (e) => Xo(/* @__PURE__ */ new Map(), e)(0), Ie = "", { toString: Qo } = {}, { keys: Ko } = Object, Re = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ge, n];
  const t = Qo.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Be, Ie];
    case "Object":
      return [Xe, Ie];
    case "Date":
      return [Dn, Ie];
    case "RegExp":
      return [On, Ie];
    case "Map":
      return [Fn, Ie];
    case "Set":
      return [_n, Ie];
    case "DataView":
      return [Be, t];
  }
  return t.includes("Array") ? [Be, t] : t.includes("Error") ? [rr, t] : [Xe, t];
}, $e = ([e, n]) => e === Ge && (n === "function" || n === "symbol"), Go = (e, n, t, r) => {
  const i = (o, a) => {
    const c = r.push(o) - 1;
    return t.set(a, c), c;
  }, l = (o) => {
    if (t.has(o))
      return t.get(o);
    let [a, c] = Re(o);
    switch (a) {
      case Ge: {
        let s = o;
        switch (c) {
          case "bigint":
            a = ir, s = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            s = null;
            break;
          case "undefined":
            return i([tr], o);
        }
        return i([a, s], o);
      }
      case Be: {
        if (c) {
          let d = o;
          return c === "DataView" ? d = new Uint8Array(o.buffer) : c === "ArrayBuffer" && (d = new Uint8Array(o)), i([c, [...d]], o);
        }
        const s = [], f = i([a, s], o);
        for (const d of o)
          s.push(l(d));
        return f;
      }
      case Xe: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return l(o.toJSON());
        const s = [], f = i([a, s], o);
        for (const d of Ko(o))
          (e || !$e(Re(o[d]))) && s.push([l(d), l(o[d])]);
        return f;
      }
      case Dn:
        return i([a, o.toISOString()], o);
      case On: {
        const { source: s, flags: f } = o;
        return i([a, { source: s, flags: f }], o);
      }
      case Fn: {
        const s = [], f = i([a, s], o);
        for (const [d, p] of o)
          (e || !($e(Re(d)) || $e(Re(p)))) && s.push([l(d), l(p)]);
        return f;
      }
      case _n: {
        const s = [], f = i([a, s], o);
        for (const d of o)
          (e || !$e(Re(d))) && s.push(l(d));
        return f;
      }
    }
    const { message: u } = o;
    return i([a, { name: c, message: u }], o);
  };
  return l;
}, dt = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return Go(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, Qe = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? mt(dt(e, n)) : structuredClone(e)
) : (e, n) => mt(dt(e, n));
function Jo(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function Zo(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function ea(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || Jo, r = e.options.footnoteBackLabel || Zo, i = e.options.footnoteLabel || "Footnotes", l = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!u)
      continue;
    const s = e.all(u), f = String(u.identifier).toUpperCase(), d = ze(f.toLowerCase());
    let p = 0;
    const w = [], C = e.footnoteCounts.get(f);
    for (; C !== void 0 && ++p <= C; ) {
      w.length > 0 && w.push({ type: "text", value: " " });
      let L = typeof t == "string" ? t : t(c, p);
      typeof L == "string" && (L = { type: "text", value: L }), w.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + d + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(L) ? L : [L]
      });
    }
    const I = s[s.length - 1];
    if (I && I.type === "element" && I.tagName === "p") {
      const L = I.children[I.children.length - 1];
      L && L.type === "text" ? L.value += " " : I.children.push({ type: "text", value: " " }), I.children.push(...w);
    } else
      s.push(...w);
    const k = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + d },
      children: e.wrap(s, !0)
    };
    e.patch(u, k), a.push(k);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: l,
          properties: {
            ...Qe(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const lr = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return ia;
    if (typeof e == "function")
      return Je(e);
    if (typeof e == "object")
      return Array.isArray(e) ? na(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        ta(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return ra(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function na(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = lr(e[t]);
  return Je(r);
  function r(...i) {
    let l = -1;
    for (; ++l < n.length; )
      if (n[l].apply(this, i)) return !0;
    return !1;
  }
}
function ta(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Je(t);
  function t(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let l;
    for (l in e)
      if (i[l] !== n[l]) return !1;
    return !0;
  }
}
function ra(e) {
  return Je(n);
  function n(t) {
    return t && t.type === e;
  }
}
function Je(e) {
  return n;
  function n(t, r, i) {
    return !!(la(t) && e.call(
      this,
      t,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function ia() {
  return !0;
}
function la(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const or = [], oa = !0, gt = !1, aa = "skip";
function ua(e, n, t, r) {
  let i;
  typeof n == "function" && typeof t != "function" ? (r = t, t = n) : i = n;
  const l = lr(i), o = r ? -1 : 1;
  a(e, void 0, [])();
  function a(c, u, s) {
    const f = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof f.type == "string") {
      const p = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(d, "name", {
        value: "node (" + (c.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return d;
    function d() {
      let p = or, w, C, I;
      if ((!n || l(c, u, s[s.length - 1] || void 0)) && (p = sa(t(c, s)), p[0] === gt))
        return p;
      if ("children" in c && c.children) {
        const k = (
          /** @type {UnistParent} */
          c
        );
        if (k.children && p[0] !== aa)
          for (C = (r ? k.children.length : -1) + o, I = s.concat(k); C > -1 && C < k.children.length; ) {
            const L = k.children[C];
            if (w = a(L, C, I)(), w[0] === gt)
              return w;
            C = typeof w[1] == "number" ? w[1] : C + o;
          }
      }
      return p;
    }
  }
}
function sa(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [oa, e] : e == null ? or : [e];
}
function ar(e, n, t, r) {
  let i, l, o;
  typeof n == "function" && typeof t != "function" ? (l = void 0, o = n, i = t) : (l = n, o = t, i = r), ua(e, l, a, i);
  function a(c, u) {
    const s = u[u.length - 1], f = s ? s.children.indexOf(c) : void 0;
    return o(c, f, s);
  }
}
const bn = {}.hasOwnProperty, ca = {};
function pa(e, n) {
  const t = n || ca, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), o = { ...Wo, ...t.handlers }, a = {
    all: u,
    applyData: ha,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: l,
    footnoteOrder: [],
    handlers: o,
    one: c,
    options: t,
    patch: fa,
    wrap: da
  };
  return ar(e, function(s) {
    if (s.type === "definition" || s.type === "footnoteDefinition") {
      const f = s.type === "definition" ? r : i, d = String(s.identifier).toUpperCase();
      f.has(d) || f.set(d, s);
    }
  }), a;
  function c(s, f) {
    const d = s.type, p = a.handlers[d];
    if (bn.call(a.handlers, d) && p)
      return p(a, s, f);
    if (a.options.passThrough && a.options.passThrough.includes(d)) {
      if ("children" in s) {
        const { children: C, ...I } = s, k = Qe(I);
        return k.children = a.all(s), k;
      }
      return Qe(s);
    }
    return (a.options.unknownHandler || ma)(a, s, f);
  }
  function u(s) {
    const f = [];
    if ("children" in s) {
      const d = s.children;
      let p = -1;
      for (; ++p < d.length; ) {
        const w = a.one(d[p], s);
        if (w) {
          if (p && d[p - 1].type === "break" && (!Array.isArray(w) && w.type === "text" && (w.value = yt(w.value)), !Array.isArray(w) && w.type === "element")) {
            const C = w.children[0];
            C && C.type === "text" && (C.value = yt(C.value));
          }
          Array.isArray(w) ? f.push(...w) : f.push(w);
        }
      }
    }
    return f;
  }
}
function fa(e, n) {
  e.position && (n.position = Yr(e));
}
function ha(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, l = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: o };
      }
    t.type === "element" && l && Object.assign(t.properties, Qe(l)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function ma(e, n) {
  const t = n.data || {}, r = "value" in n && !(bn.call(t, "hProperties") || bn.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function da(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function yt(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function xt(e, n) {
  const t = pa(e, n), r = t.one(e, void 0), i = ea(t), l = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && l.children.push({ type: "text", value: `
` }, i), l;
}
function ga(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      xt(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      xt(t, { file: r, ...e || n })
    );
  };
}
function kt(e) {
  if (e)
    throw e;
}
var ln, bt;
function ya() {
  if (bt) return ln;
  bt = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(u) {
    return typeof Array.isArray == "function" ? Array.isArray(u) : n.call(u) === "[object Array]";
  }, l = function(u) {
    if (!u || n.call(u) !== "[object Object]")
      return !1;
    var s = e.call(u, "constructor"), f = u.constructor && u.constructor.prototype && e.call(u.constructor.prototype, "isPrototypeOf");
    if (u.constructor && !s && !f)
      return !1;
    var d;
    for (d in u)
      ;
    return typeof d > "u" || e.call(u, d);
  }, o = function(u, s) {
    t && s.name === "__proto__" ? t(u, s.name, {
      enumerable: !0,
      configurable: !0,
      value: s.newValue,
      writable: !0
    }) : u[s.name] = s.newValue;
  }, a = function(u, s) {
    if (s === "__proto__")
      if (e.call(u, s)) {
        if (r)
          return r(u, s).value;
      } else return;
    return u[s];
  };
  return ln = function c() {
    var u, s, f, d, p, w, C = arguments[0], I = 1, k = arguments.length, L = !1;
    for (typeof C == "boolean" && (L = C, C = arguments[1] || {}, I = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); I < k; ++I)
      if (u = arguments[I], u != null)
        for (s in u)
          f = a(C, s), d = a(u, s), C !== d && (L && d && (l(d) || (p = i(d))) ? (p ? (p = !1, w = f && i(f) ? f : []) : w = f && l(f) ? f : {}, o(C, { name: s, newValue: c(L, w, d) })) : typeof d < "u" && o(C, { name: s, newValue: d }));
    return C;
  }, ln;
}
var xa = ya();
const on = /* @__PURE__ */ Pt(xa);
function wn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ka() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let l = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...i);
    function a(c, ...u) {
      const s = e[++l];
      let f = -1;
      if (c) {
        o(c);
        return;
      }
      for (; ++f < i.length; )
        (u[f] === null || u[f] === void 0) && (u[f] = i[f]);
      i = u, s ? ba(s, a)(...u) : o(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function ba(e, n) {
  let t;
  return r;
  function r(...o) {
    const a = e.length > o.length;
    let c;
    a && o.push(i);
    try {
      c = e.apply(this, o);
    } catch (u) {
      const s = (
        /** @type {Error} */
        u
      );
      if (a && t)
        throw s;
      return i(s);
    }
    a || (c && c.then && typeof c.then == "function" ? c.then(l, i) : c instanceof Error ? i(c) : l(c));
  }
  function i(o, ...a) {
    t || (t = !0, n(o, ...a));
  }
  function l(o) {
    i(null, o);
  }
}
const ae = { basename: wa, dirname: Sa, extname: Ca, join: Ea, sep: "/" };
function wa(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Ue(e);
  let t = 0, r = -1, i = e.length, l;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (l) {
          t = i + 1;
          break;
        }
      } else r < 0 && (l = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let o = -1, a = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (l) {
        t = i + 1;
        break;
      }
    } else
      o < 0 && (l = !0, o = i + 1), a > -1 && (e.codePointAt(i) === n.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
  return t === r ? r = o : r < 0 && (r = e.length), e.slice(t, r);
}
function Sa(e) {
  if (Ue(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function Ca(e) {
  Ue(e);
  let n = e.length, t = -1, r = 0, i = -1, l = 0, o;
  for (; n--; ) {
    const a = e.codePointAt(n);
    if (a === 47) {
      if (o) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), a === 46 ? i < 0 ? i = n : l !== 1 && (l = 1) : i > -1 && (l = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  l === 0 || // The (right-most) trimmed path component is exactly `..`.
  l === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function Ea(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    Ue(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : Ia(t);
}
function Ia(e) {
  Ue(e);
  const n = e.codePointAt(0) === 47;
  let t = Ta(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function Ta(e, n) {
  let t = "", r = 0, i = -1, l = 0, o = -1, a, c;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || l === 1)) if (i !== o - 1 && l === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (c = t.lastIndexOf("/"), c !== t.length - 1) {
              c < 0 ? (t = "", r = 0) : (t = t.slice(0, c), r = t.length - 1 - t.lastIndexOf("/")), i = o, l = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = o, l = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, o) : t = e.slice(i + 1, o), r = o - i - 1;
      i = o, l = 0;
    } else a === 46 && l > -1 ? l++ : l = -1;
  }
  return t;
}
function Ue(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Pa = { cwd: Aa };
function Aa() {
  return "/";
}
function Sn(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function za(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Sn(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return La(e);
}
function La(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const an = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class ur {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Sn(n) ? t = { path: n } : typeof n == "string" || va(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : Pa.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < an.length; ) {
      const l = an[r];
      l in t && t[l] !== void 0 && t[l] !== null && (this[l] = l === "history" ? [...t[l]] : t[l]);
    }
    let i;
    for (i in t)
      an.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? ae.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    sn(n, "basename"), un(n, "basename"), this.path = ae.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? ae.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    wt(this.basename, "dirname"), this.path = ae.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? ae.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (un(n, "extname"), wt(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = ae.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Sn(n) && (n = za(n)), sn(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? ae.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    sn(n, "stem"), un(n, "stem"), this.path = ae.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new Q(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function un(e, n) {
  if (e && e.includes(ae.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + ae.sep + "`"
    );
}
function sn(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function wt(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function va(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Da = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], l = function() {
      return i.apply(l, arguments);
    };
    return Object.setPrototypeOf(l, r), l;
  })
), Oa = {}.hasOwnProperty;
class Rn extends Da {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = ka();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Rn()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(on(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (fn("data", this.frozen), this.namespace[n] = t, this) : Oa.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (fn("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = We(n), r = this.parser || this.Parser;
    return cn("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), cn("process", this.parser || this.Parser), pn("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(l, o) {
      const a = We(n), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(c, a, function(s, f, d) {
        if (s || !f || !d)
          return u(s);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), w = r.stringify(p, d);
        Ra(w) ? d.value = w : d.result = w, u(
          s,
          /** @type {VFileWithOutput<CompileResult>} */
          d
        );
      });
      function u(s, f) {
        s || !f ? o(s) : l ? l(f) : t(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), cn("processSync", this.parser || this.Parser), pn("processSync", this.compiler || this.Compiler), this.process(n, i), Ct("processSync", "process", t), r;
    function i(l, o) {
      t = !0, kt(l), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    St(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? l(void 0, r) : new Promise(l);
    function l(o, a) {
      const c = We(t);
      i.run(n, c, u);
      function u(s, f, d) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        s ? a(s) : o ? o(p) : r(void 0, p, d);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, l), Ct("runSync", "run", r), i;
    function l(o, a) {
      kt(o), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = We(t), i = this.compiler || this.Compiler;
    return pn("stringify", i), St(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (fn("use", this.frozen), n != null) if (typeof n == "function")
      c(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? a(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function l(u) {
      if (typeof u == "function")
        c(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [s, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          c(s, f);
        } else
          o(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function o(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(u.plugins), u.settings && (i.settings = on(!0, i.settings, u.settings));
    }
    function a(u) {
      let s = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++s < u.length; ) {
          const f = u[s];
          l(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function c(u, s) {
      let f = -1, d = -1;
      for (; ++f < r.length; )
        if (r[f][0] === u) {
          d = f;
          break;
        }
      if (d === -1)
        r.push([u, ...s]);
      else if (s.length > 0) {
        let [p, ...w] = s;
        const C = r[d][1];
        wn(C) && wn(p) && (p = on(!0, C, p)), r[d] = [u, p, ...w];
      }
    }
  }
}
const Fa = new Rn().freeze();
function cn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function pn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function fn(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function St(e) {
  if (!wn(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ct(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function We(e) {
  return _a(e) ? e : new ur(e);
}
function _a(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Ra(e) {
  return typeof e == "string" || Na(e);
}
function Na(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Ma = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Et = [], It = { allowDangerousHtml: !0 }, Ba = /^(https?|ircs?|mailto|xmpp)$/i, ja = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Ha(e) {
  const n = Ua(e), t = Va(e);
  return qa(n.runSync(n.parse(t), t), e);
}
function Ua(e) {
  const n = e.rehypePlugins || Et, t = e.remarkPlugins || Et, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...It } : It;
  return Fa().use(bo).use(t).use(ga, r).use(n);
}
function Va(e) {
  const n = e.children || "", t = new ur();
  return typeof n == "string" && (t.value = n), t;
}
function qa(e, n) {
  const t = n.allowedElements, r = n.allowElement, i = n.components, l = n.disallowedElements, o = n.skipHtml, a = n.unwrapDisallowed, c = n.urlTransform || $a;
  for (const s of ja)
    Object.hasOwn(n, s.from) && ("" + s.from + (s.to ? "use `" + s.to + "` instead" : "remove it") + Ma + s.id, void 0);
  return ar(e, u), Jr(e, {
    Fragment: xr,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: Pe,
    jsxs: Tt,
    passKeys: !0,
    passNode: !0
  });
  function u(s, f, d) {
    if (s.type === "raw" && d && typeof f == "number")
      return o ? d.children.splice(f, 1) : d.children[f] = { type: "text", value: s.value }, f;
    if (s.type === "element") {
      let p;
      for (p in nn)
        if (Object.hasOwn(nn, p) && Object.hasOwn(s.properties, p)) {
          const w = s.properties[p], C = nn[p];
          (C === null || C.includes(s.tagName)) && (s.properties[p] = c(String(w || ""), p, s));
        }
    }
    if (s.type === "element") {
      let p = t ? !t.includes(s.tagName) : l ? l.includes(s.tagName) : !1;
      if (!p && r && typeof f == "number" && (p = !r(s, f, d)), p && d && typeof f == "number")
        return a && s.children ? d.children.splice(f, 1, ...s.children) : d.children.splice(f, 1), f;
    }
  }
}
function $a(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && n > i || t !== -1 && n > t || r !== -1 && n > r || // It is a protocol, it should be allowed.
    Ba.test(e.slice(0, n)) ? e : ""
  );
}
const nu = ({ field: e }) => (e.Flags & Cr.Markdown) > 0 ? /* @__PURE__ */ Pe(Ha, { children: e.Caption }) : /* @__PURE__ */ Pe(Wa, { text: e.Caption }), Wa = ({ text: e }) => {
  const n = /\bhttps?:\/\/[^\s<>"'(),[\]]+/, t = /(<[^>]+>)/, r = e.split(t), i = [];
  return r.forEach((l, o) => {
    if (!l.match(t)) {
      const a = l.split(n), c = l.match(new RegExp(n, "ig")) || [];
      for (let u = 0; u < a.length; u++)
        a[u] && i.push(a[u]), u < c.length && i.push(
          /* @__PURE__ */ Pe(Ya, { url: c[u] }, `${o}-${u}`)
        );
    }
  }), /* @__PURE__ */ Pe(kr, { align: "center", sx: { display: "inline-flex" }, children: i });
}, Ya = ({ url: e }) => {
  const n = async () => {
    await wr.open({ url: e });
  };
  return Sr.isNativePlatform() ? /* @__PURE__ */ Pe(br, { variant: "text", onClick: n, children: e }) : /* @__PURE__ */ Tt("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: [
    " ",
    e,
    " "
  ] });
};
export {
  nu as L,
  Ha as M,
  Wa as S
};
//# sourceMappingURL=Label-D4G1pphV.js.map
